// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/integrations.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { ErrorInfo } from "./common";

export const protobufPackage = "api.devplan.types.integrations";

export enum TicketProvider {
  TICKET_PROVIDER_UNSPECIFIED = 0,
  TICKET_PROVIDER_JIRA = 1,
  TICKET_PROVIDER_LINEAR = 2,
}

export function ticketProviderFromJSON(object: any): TicketProvider {
  switch (object) {
    case 0:
    case "TICKET_PROVIDER_UNSPECIFIED":
      return TicketProvider.TICKET_PROVIDER_UNSPECIFIED;
    case 1:
    case "TICKET_PROVIDER_JIRA":
      return TicketProvider.TICKET_PROVIDER_JIRA;
    case 2:
    case "TICKET_PROVIDER_LINEAR":
      return TicketProvider.TICKET_PROVIDER_LINEAR;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum TicketProvider");
  }
}

export function ticketProviderToJSON(object: TicketProvider): string {
  switch (object) {
    case TicketProvider.TICKET_PROVIDER_UNSPECIFIED:
      return "TICKET_PROVIDER_UNSPECIFIED";
    case TicketProvider.TICKET_PROVIDER_JIRA:
      return "TICKET_PROVIDER_JIRA";
    case TicketProvider.TICKET_PROVIDER_LINEAR:
      return "TICKET_PROVIDER_LINEAR";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum TicketProvider");
  }
}

export enum GitProvider {
  GITHUB = 0,
  BIT_BUCKET = 1,
  GITLAB = 2,
}

export function gitProviderFromJSON(object: any): GitProvider {
  switch (object) {
    case 0:
    case "GITHUB":
      return GitProvider.GITHUB;
    case 1:
    case "BIT_BUCKET":
      return GitProvider.BIT_BUCKET;
    case 2:
    case "GITLAB":
      return GitProvider.GITLAB;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum GitProvider");
  }
}

export function gitProviderToJSON(object: GitProvider): string {
  switch (object) {
    case GitProvider.GITHUB:
      return "GITHUB";
    case GitProvider.BIT_BUCKET:
      return "BIT_BUCKET";
    case GitProvider.GITLAB:
      return "GITLAB";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum GitProvider");
  }
}

export enum GitLabRepositoryDiscoveryStatus {
  GITLAB_REPOSITORY_DISCOVERY_STATUS_UNSPECIFIED = 0,
  GITLAB_REPOSITORY_DISCOVERY_STATUS_HEALTHY = 1,
  GITLAB_REPOSITORY_DISCOVERY_STATUS_DEGRADED = 2,
}

export function gitLabRepositoryDiscoveryStatusFromJSON(object: any): GitLabRepositoryDiscoveryStatus {
  switch (object) {
    case 0:
    case "GITLAB_REPOSITORY_DISCOVERY_STATUS_UNSPECIFIED":
      return GitLabRepositoryDiscoveryStatus.GITLAB_REPOSITORY_DISCOVERY_STATUS_UNSPECIFIED;
    case 1:
    case "GITLAB_REPOSITORY_DISCOVERY_STATUS_HEALTHY":
      return GitLabRepositoryDiscoveryStatus.GITLAB_REPOSITORY_DISCOVERY_STATUS_HEALTHY;
    case 2:
    case "GITLAB_REPOSITORY_DISCOVERY_STATUS_DEGRADED":
      return GitLabRepositoryDiscoveryStatus.GITLAB_REPOSITORY_DISCOVERY_STATUS_DEGRADED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum GitLabRepositoryDiscoveryStatus");
  }
}

export function gitLabRepositoryDiscoveryStatusToJSON(object: GitLabRepositoryDiscoveryStatus): string {
  switch (object) {
    case GitLabRepositoryDiscoveryStatus.GITLAB_REPOSITORY_DISCOVERY_STATUS_UNSPECIFIED:
      return "GITLAB_REPOSITORY_DISCOVERY_STATUS_UNSPECIFIED";
    case GitLabRepositoryDiscoveryStatus.GITLAB_REPOSITORY_DISCOVERY_STATUS_HEALTHY:
      return "GITLAB_REPOSITORY_DISCOVERY_STATUS_HEALTHY";
    case GitLabRepositoryDiscoveryStatus.GITLAB_REPOSITORY_DISCOVERY_STATUS_DEGRADED:
      return "GITLAB_REPOSITORY_DISCOVERY_STATUS_DEGRADED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum GitLabRepositoryDiscoveryStatus");
  }
}

export enum GitLabTokenAccessStatus {
  GITLAB_TOKEN_ACCESS_STATUS_UNSPECIFIED = 0,
  GITLAB_TOKEN_ACCESS_STATUS_HEALTHY = 1,
  GITLAB_TOKEN_ACCESS_STATUS_DEGRADED = 2,
}

export function gitLabTokenAccessStatusFromJSON(object: any): GitLabTokenAccessStatus {
  switch (object) {
    case 0:
    case "GITLAB_TOKEN_ACCESS_STATUS_UNSPECIFIED":
      return GitLabTokenAccessStatus.GITLAB_TOKEN_ACCESS_STATUS_UNSPECIFIED;
    case 1:
    case "GITLAB_TOKEN_ACCESS_STATUS_HEALTHY":
      return GitLabTokenAccessStatus.GITLAB_TOKEN_ACCESS_STATUS_HEALTHY;
    case 2:
    case "GITLAB_TOKEN_ACCESS_STATUS_DEGRADED":
      return GitLabTokenAccessStatus.GITLAB_TOKEN_ACCESS_STATUS_DEGRADED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum GitLabTokenAccessStatus");
  }
}

export function gitLabTokenAccessStatusToJSON(object: GitLabTokenAccessStatus): string {
  switch (object) {
    case GitLabTokenAccessStatus.GITLAB_TOKEN_ACCESS_STATUS_UNSPECIFIED:
      return "GITLAB_TOKEN_ACCESS_STATUS_UNSPECIFIED";
    case GitLabTokenAccessStatus.GITLAB_TOKEN_ACCESS_STATUS_HEALTHY:
      return "GITLAB_TOKEN_ACCESS_STATUS_HEALTHY";
    case GitLabTokenAccessStatus.GITLAB_TOKEN_ACCESS_STATUS_DEGRADED:
      return "GITLAB_TOKEN_ACCESS_STATUS_DEGRADED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum GitLabTokenAccessStatus");
  }
}

export enum GitLabTokenRotationStatus {
  GITLAB_TOKEN_ROTATION_STATUS_UNSPECIFIED = 0,
  GITLAB_TOKEN_ROTATION_STATUS_ACTIVE = 1,
  GITLAB_TOKEN_ROTATION_STATUS_UNAVAILABLE = 2,
  GITLAB_TOKEN_ROTATION_STATUS_NEEDS_ATTENTION = 3,
}

export function gitLabTokenRotationStatusFromJSON(object: any): GitLabTokenRotationStatus {
  switch (object) {
    case 0:
    case "GITLAB_TOKEN_ROTATION_STATUS_UNSPECIFIED":
      return GitLabTokenRotationStatus.GITLAB_TOKEN_ROTATION_STATUS_UNSPECIFIED;
    case 1:
    case "GITLAB_TOKEN_ROTATION_STATUS_ACTIVE":
      return GitLabTokenRotationStatus.GITLAB_TOKEN_ROTATION_STATUS_ACTIVE;
    case 2:
    case "GITLAB_TOKEN_ROTATION_STATUS_UNAVAILABLE":
      return GitLabTokenRotationStatus.GITLAB_TOKEN_ROTATION_STATUS_UNAVAILABLE;
    case 3:
    case "GITLAB_TOKEN_ROTATION_STATUS_NEEDS_ATTENTION":
      return GitLabTokenRotationStatus.GITLAB_TOKEN_ROTATION_STATUS_NEEDS_ATTENTION;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum GitLabTokenRotationStatus");
  }
}

export function gitLabTokenRotationStatusToJSON(object: GitLabTokenRotationStatus): string {
  switch (object) {
    case GitLabTokenRotationStatus.GITLAB_TOKEN_ROTATION_STATUS_UNSPECIFIED:
      return "GITLAB_TOKEN_ROTATION_STATUS_UNSPECIFIED";
    case GitLabTokenRotationStatus.GITLAB_TOKEN_ROTATION_STATUS_ACTIVE:
      return "GITLAB_TOKEN_ROTATION_STATUS_ACTIVE";
    case GitLabTokenRotationStatus.GITLAB_TOKEN_ROTATION_STATUS_UNAVAILABLE:
      return "GITLAB_TOKEN_ROTATION_STATUS_UNAVAILABLE";
    case GitLabTokenRotationStatus.GITLAB_TOKEN_ROTATION_STATUS_NEEDS_ATTENTION:
      return "GITLAB_TOKEN_ROTATION_STATUS_NEEDS_ATTENTION";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum GitLabTokenRotationStatus");
  }
}

export enum NotionRootObjectType {
  NOTION_ROOT_OBJECT_TYPE_UNSPECIFIED = 0,
  NOTION_ROOT_OBJECT_TYPE_PAGE = 1,
  NOTION_ROOT_OBJECT_TYPE_DATABASE = 2,
}

export function notionRootObjectTypeFromJSON(object: any): NotionRootObjectType {
  switch (object) {
    case 0:
    case "NOTION_ROOT_OBJECT_TYPE_UNSPECIFIED":
      return NotionRootObjectType.NOTION_ROOT_OBJECT_TYPE_UNSPECIFIED;
    case 1:
    case "NOTION_ROOT_OBJECT_TYPE_PAGE":
      return NotionRootObjectType.NOTION_ROOT_OBJECT_TYPE_PAGE;
    case 2:
    case "NOTION_ROOT_OBJECT_TYPE_DATABASE":
      return NotionRootObjectType.NOTION_ROOT_OBJECT_TYPE_DATABASE;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum NotionRootObjectType");
  }
}

export function notionRootObjectTypeToJSON(object: NotionRootObjectType): string {
  switch (object) {
    case NotionRootObjectType.NOTION_ROOT_OBJECT_TYPE_UNSPECIFIED:
      return "NOTION_ROOT_OBJECT_TYPE_UNSPECIFIED";
    case NotionRootObjectType.NOTION_ROOT_OBJECT_TYPE_PAGE:
      return "NOTION_ROOT_OBJECT_TYPE_PAGE";
    case NotionRootObjectType.NOTION_ROOT_OBJECT_TYPE_DATABASE:
      return "NOTION_ROOT_OBJECT_TYPE_DATABASE";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum NotionRootObjectType");
  }
}

export enum ConfluenceRootObjectType {
  CONFLUENCE_ROOT_OBJECT_TYPE_UNSPECIFIED = 0,
  CONFLUENCE_ROOT_OBJECT_TYPE_PAGE = 1,
  CONFLUENCE_ROOT_OBJECT_TYPE_SPACE = 2,
}

export function confluenceRootObjectTypeFromJSON(object: any): ConfluenceRootObjectType {
  switch (object) {
    case 0:
    case "CONFLUENCE_ROOT_OBJECT_TYPE_UNSPECIFIED":
      return ConfluenceRootObjectType.CONFLUENCE_ROOT_OBJECT_TYPE_UNSPECIFIED;
    case 1:
    case "CONFLUENCE_ROOT_OBJECT_TYPE_PAGE":
      return ConfluenceRootObjectType.CONFLUENCE_ROOT_OBJECT_TYPE_PAGE;
    case 2:
    case "CONFLUENCE_ROOT_OBJECT_TYPE_SPACE":
      return ConfluenceRootObjectType.CONFLUENCE_ROOT_OBJECT_TYPE_SPACE;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ConfluenceRootObjectType");
  }
}

export function confluenceRootObjectTypeToJSON(object: ConfluenceRootObjectType): string {
  switch (object) {
    case ConfluenceRootObjectType.CONFLUENCE_ROOT_OBJECT_TYPE_UNSPECIFIED:
      return "CONFLUENCE_ROOT_OBJECT_TYPE_UNSPECIFIED";
    case ConfluenceRootObjectType.CONFLUENCE_ROOT_OBJECT_TYPE_PAGE:
      return "CONFLUENCE_ROOT_OBJECT_TYPE_PAGE";
    case ConfluenceRootObjectType.CONFLUENCE_ROOT_OBJECT_TYPE_SPACE:
      return "CONFLUENCE_ROOT_OBJECT_TYPE_SPACE";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ConfluenceRootObjectType");
  }
}

export interface ExternalId {
  type: ExternalId_ExternalType;
  id: string;
}

export enum ExternalId_ExternalType {
  UNKNOWN = 0,
  ISSUE = 1,
  PROJECT = 2,
}

export function externalId_ExternalTypeFromJSON(object: any): ExternalId_ExternalType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ExternalId_ExternalType.UNKNOWN;
    case 1:
    case "ISSUE":
      return ExternalId_ExternalType.ISSUE;
    case 2:
    case "PROJECT":
      return ExternalId_ExternalType.PROJECT;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ExternalId_ExternalType");
  }
}

export function externalId_ExternalTypeToJSON(object: ExternalId_ExternalType): string {
  switch (object) {
    case ExternalId_ExternalType.UNKNOWN:
      return "UNKNOWN";
    case ExternalId_ExternalType.ISSUE:
      return "ISSUE";
    case ExternalId_ExternalType.PROJECT:
      return "PROJECT";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ExternalId_ExternalType");
  }
}

export interface LinkedDocumentInfo {
  documentId: string;
  companyId: number;
  externalId: ExternalId | undefined;
  data: { $case: "linear"; value: LinearDocumentLinkInfo } | { $case: "jira"; value: JiraDocumentLinkInfo } | undefined;
}

export interface LinearDocumentLinkInfo {
  info: { $case: "issue"; value: LinearIssue } | { $case: "project"; value: LinearProject } | undefined;
}

export interface JiraDocumentLinkInfo {
  info: { $case: "issue"; value: JiraIssue } | { $case: "epic"; value: JiraProject } | undefined;
}

export interface IntegrationInfo {
  info:
    | { $case: "linear"; value: LinearIntegrationInfo }
    | { $case: "github"; value: GitHubIntegrationInfo }
    | { $case: "jira"; value: JiraIntegrationInfo }
    | { $case: "bitBucket"; value: BitBucketIntegrationInfo }
    | { $case: "slack"; value: SlackIntegrationInfo }
    | { $case: "notion"; value: NotionIntegrationInfo }
    | { $case: "confluence"; value: ConfluenceIntegrationInfo }
    | { $case: "teams"; value: TeamsIntegrationInfo }
    | { $case: "gitlab"; value: GitLabIntegrationInfo }
    | { $case: "zoom"; value: ZoomIntegrationInfo }
    | undefined;
}

export interface ZoomIntegrationInfo {
  accountId: string;
  userId: string;
  email: string;
}

export interface LinearIssue {
  id: string;
  teamId: string;
  identifier: string;
  url: string;
}

export interface LinearProject {
  id: string;
  url: string;
}

export interface LinearOrganization {
  id: string;
  name: string;
  urlKey: string;
}

export interface LinearTeam {
  id: string;
  name: string;
  key: string;
}

export interface LinearIntegrationInfo {
  organization: LinearOrganization | undefined;
  teams: LinearTeam[];
}

export interface GitRepository {
  id: string;
  name: string;
  fullName: string;
  url: string;
  description: string;
  provider: GitProvider;
}

export interface GitHubOrganization {
  id: string;
  name: string;
  url: string;
}

export interface GitHubIntegrationInfo {
  organization: GitHubOrganization | undefined;
  repositories: GitRepository[];
}

export interface BitBucketIntegrationInfo {
  integrations: BitBucketWorkspaceIntegration[];
  availableWorkspaces: BitBucketWorkspace[];
}

export interface BitBucketWorkspaceIntegration {
  workspace: BitBucketWorkspace | undefined;
  repositories: GitRepository[];
}

export interface BitBucketWorkspace {
  uuid: string;
  name?: string | undefined;
  slug: string;
  url: string;
}

export interface GitLabIntegrationInfo {
  repositories: GitRepository[];
  tokenAccess: GitLabTokenAccessState | undefined;
  repositoryDiscovery: GitLabRepositoryDiscoveryState | undefined;
  tokenRotation: GitLabTokenRotationState | undefined;
  connectedAt?: Date | undefined;
}

export interface GitLabTokenAccessState {
  status: GitLabTokenAccessStatus;
  errorMessage: string;
  tokenExpiresAt?: Date | undefined;
}

export interface GitLabRepositoryDiscoveryState {
  status: GitLabRepositoryDiscoveryStatus;
  errorMessage: string;
  lastSuccessfulAt?: Date | undefined;
}

export interface GitLabTokenRotationState {
  status: GitLabTokenRotationStatus;
  errorMessage: string;
  nextRotationAt?: Date | undefined;
}

export interface JiraOrganization {
  id: string;
  name: string;
  url: string;
}

export interface JiraTeam {
  id: string;
  name: string;
  key: string;
}

export interface JiraIntegrationInfo {
  organization: JiraOrganization | undefined;
  teams: JiraTeam[];
}

export interface JiraIssue {
  id: string;
  teamId: string;
  identifier: string;
  url: string;
}

export interface JiraProject {
  id: string;
  key: string;
  url: string;
  teamId: string;
}

export interface IntegrationProperties {
  linear?: LinearIntegrationProperties | undefined;
  github?: GitHubIntegrationProperties | undefined;
  jira?: JiraIntegrationProperties | undefined;
}

export interface LinearIntegrationProperties {
  noLinkBack: boolean;
  includePrompts: boolean;
  excludeUserStoryPrompts: boolean;
}

export interface GitHubIntegrationProperties {
}

export interface JiraIntegrationProperties {
  noLinkBack: boolean;
  includePrompts: boolean;
  extraFields: string[];
  allowedProjectKeys: string[];
  excludeUserStoryPrompts: boolean;
}

export interface SlackWorkspace {
  id: string;
  name: string;
  domain: string;
  url: string;
}

export interface SlackIntegrationInfo {
  workspace: SlackWorkspace | undefined;
}

/** Durable delivery state for the Slack onboarding message sequence. */
export interface SlackOnboardingMessage {
  companyId: number;
  slackWorkspaceId: string;
  slackUserId: string;
  devplanUserId: string;
  dmChannelId?: string | undefined;
  welcomeSentAt?: Date | undefined;
  companyProfileSentAt?: Date | undefined;
  competitiveAnalysisSentAt?: Date | undefined;
  productGraphSentAt?: Date | undefined;
  retryCount: number;
  nextAttemptAt: Date | undefined;
  claimLeaseUntil?: Date | undefined;
  lastError?: string | undefined;
  pausedAt?: Date | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

/**
 * Microsoft Teams lives on one Azure AD tenant; the integration is connected
 * per-workspace and may span multiple Teams (groups). Channels are discovered
 * live via Graph rather than persisted here.
 */
export interface TeamsTenant {
  id: string;
  name: string;
}

export interface TeamsTeam {
  id: string;
  displayName: string;
}

export interface TeamsChannel {
  id: string;
  displayName: string;
  teamId: string;
}

export interface TeamsIntegrationInfo {
  tenant: TeamsTenant | undefined;
  teams: TeamsTeam[];
  /**
   * Bot Framework serviceUrl for the tenant, captured from any inbound bot
   * activity (including app install — no channel selection required first).
   * Tenant-wide; needed for proactive posts (digest). Empty until the Devplan
   * app has been installed in a team.
   */
  serviceUrl: string;
  /**
   * Azure AD group ids for teams where Bot Framework activity proves the
   * Devplan bot is currently installed. Used to authorize proactive posts.
   */
  installedTeamIds: string[];
}

export interface NotionRoot {
  id: string;
  title: string;
  objectType: NotionRootObjectType;
  url: string;
}

export interface NotionIntegrationInfo {
  roots: NotionRoot[];
}

/** One item the caller wants to attach to a Notion signal bucket. */
export interface AttachNotionItem {
  notionRootId: string;
  /** Empty string means "attach the root itself" (a page, or a whole database). */
  notionPageId: string;
  objectType: NotionRootObjectType;
  title: string;
  url: string;
  parentTitle: string;
  lastEditedTime: string;
}

/** One child page returned when the picker dialog drills into a Notion database. */
export interface NotionPageSummary {
  id: string;
  title: string;
  url: string;
  lastEditedTime: string;
}

export interface ConfluenceRoot {
  /** Confluence id of the space (when object_type=SPACE) or page (when object_type=PAGE). */
  id: string;
  title: string;
  objectType: ConfluenceRootObjectType;
  url: string;
  /**
   * Populated for both SPACE and PAGE roots so the picker can scope page lookups
   * by space without an extra round-trip.
   */
  spaceKey: string;
}

export interface ConfluenceIntegrationInfo {
  /**
   * Atlassian cloud id captured during the 3LO connect's accessible-resources
   * call. All runtime Confluence REST calls need this in the URL path.
   */
  cloudId: string;
  /** https://<your-domain>.atlassian.net — kept for breadcrumb / display. */
  siteUrl: string;
  roots: ConfluenceRoot[];
  /**
   * ISO-8601 timestamp of the last successful roots sync. Presence means an
   * empty roots list is a known synced state, not "not loaded yet".
   */
  rootsSyncedAt: string;
  /**
   * ISO-8601 timestamp set when the user explicitly disconnects Confluence.
   * This tombstone prevents lazy Jira-to-Confluence migration from undoing the
   * disconnect while Jira remains connected.
   */
  disconnectedAt: string;
}

/** One item the caller wants to attach to a Confluence signal bucket. */
export interface AttachConfluenceItem {
  cloudId: string;
  /**
   * For SPACE attachments, this is the space id and confluence_page_id is empty.
   * For PAGE attachments under a space root, space_id locates the parent space.
   */
  spaceId: string;
  spaceKey: string;
  /** Empty means "attach the root itself" (whole space or root page). */
  confluencePageId: string;
  objectType: ConfluenceRootObjectType;
  title: string;
  url: string;
  parentTitle: string;
  lastEditedTime: string;
}

/** One child page returned when the picker dialog drills into a Confluence space. */
export interface ConfluencePageSummary {
  id: string;
  title: string;
  url: string;
  lastEditedTime: string;
}

export interface GoogleDriveFolder {
  id: string;
  name: string;
  isDrive: boolean;
}

export interface GoogleDriveFile {
  id: string;
  name: string;
  mimeType: string;
  url: string;
}

export interface RepoMetadata {
  id: string;
  companyId: number;
  analysis:
    | RepoAnalysisSettings
    | undefined;
  /** Id of the repository in dev-observer if present. */
  observerId?: string | undefined;
  provider: GitProvider;
}

export interface RepoAnalysisSettings {
  optOut: boolean;
}

export interface RepositorySummary {
  id: string;
  summary?: string | undefined;
  error?: ErrorInfo | undefined;
  repoName: string;
  companyId: number;
  provider: GitProvider;
  shortSummary?: string | undefined;
  updatedAt?: Date | undefined;
}

export interface CodeResearchOrgMeta {
  /** JSON-serialized contextify CodeResearchOrganizationMeta */
  data: string;
}

export interface WebSiteSummary {
  url: string;
  summary?: string | undefined;
  error?: ErrorInfo | undefined;
  companyId: number;
}

export interface SignedLink {
  id: string;
  expiresAt: Date | undefined;
  companyId: number;
  target: SignedLinkTarget | undefined;
}

export interface SignedLinkTarget {
  type: { $case: "documentContent"; value: SignedLinkTarget_DocumentContent } | undefined;
}

export interface SignedLinkTarget_DocumentContent {
  id: string;
}

export interface JiraField {
  id: string;
  key: string;
  name: string;
  type: JiraField_JiraFieldType;
  required: boolean;
  hasDefault: boolean;
  schema?: JiraFieldSchema | undefined;
  options: JiraFieldOption[];
}

export enum JiraField_JiraFieldType {
  UNKNOWN = 0,
  SELECT = 1,
  DATE = 2,
  TEXT = 3,
  TEXT_AREA = 4,
  MULTI_SELECT = 5,
}

export function jiraField_JiraFieldTypeFromJSON(object: any): JiraField_JiraFieldType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return JiraField_JiraFieldType.UNKNOWN;
    case 1:
    case "SELECT":
      return JiraField_JiraFieldType.SELECT;
    case 2:
    case "DATE":
      return JiraField_JiraFieldType.DATE;
    case 3:
    case "TEXT":
      return JiraField_JiraFieldType.TEXT;
    case 4:
    case "TEXT_AREA":
      return JiraField_JiraFieldType.TEXT_AREA;
    case 5:
    case "MULTI_SELECT":
      return JiraField_JiraFieldType.MULTI_SELECT;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum JiraField_JiraFieldType");
  }
}

export function jiraField_JiraFieldTypeToJSON(object: JiraField_JiraFieldType): string {
  switch (object) {
    case JiraField_JiraFieldType.UNKNOWN:
      return "UNKNOWN";
    case JiraField_JiraFieldType.SELECT:
      return "SELECT";
    case JiraField_JiraFieldType.DATE:
      return "DATE";
    case JiraField_JiraFieldType.TEXT:
      return "TEXT";
    case JiraField_JiraFieldType.TEXT_AREA:
      return "TEXT_AREA";
    case JiraField_JiraFieldType.MULTI_SELECT:
      return "MULTI_SELECT";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum JiraField_JiraFieldType");
  }
}

export interface JiraFieldSchema {
  items?: string | undefined;
  custom?: string | undefined;
}

export interface JiraFieldOption {
  id: string;
  value: string;
  label: string;
}

function createBaseExternalId(): ExternalId {
  return { type: 0, id: "" };
}

export const ExternalId: MessageFns<ExternalId> = {
  encode(message: ExternalId, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExternalId {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExternalId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExternalId {
    return {
      type: isSet(object.type) ? externalId_ExternalTypeFromJSON(object.type) : 0,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: ExternalId): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = externalId_ExternalTypeToJSON(message.type);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<ExternalId>): ExternalId {
    return ExternalId.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ExternalId>): ExternalId {
    const message = createBaseExternalId();
    message.type = object.type ?? 0;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseLinkedDocumentInfo(): LinkedDocumentInfo {
  return { documentId: "", companyId: 0, externalId: undefined, data: undefined };
}

export const LinkedDocumentInfo: MessageFns<LinkedDocumentInfo> = {
  encode(message: LinkedDocumentInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentId !== "") {
      writer.uint32(10).string(message.documentId);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.externalId !== undefined) {
      ExternalId.encode(message.externalId, writer.uint32(26).fork()).join();
    }
    switch (message.data?.$case) {
      case "linear":
        LinearDocumentLinkInfo.encode(message.data.value, writer.uint32(802).fork()).join();
        break;
      case "jira":
        JiraDocumentLinkInfo.encode(message.data.value, writer.uint32(810).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinkedDocumentInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinkedDocumentInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.externalId = ExternalId.decode(reader, reader.uint32());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.data = { $case: "linear", value: LinearDocumentLinkInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.data = { $case: "jira", value: JiraDocumentLinkInfo.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinkedDocumentInfo {
    return {
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      externalId: isSet(object.externalId)
        ? ExternalId.fromJSON(object.externalId)
        : isSet(object.external_id)
        ? ExternalId.fromJSON(object.external_id)
        : undefined,
      data: isSet(object.linear)
        ? { $case: "linear", value: LinearDocumentLinkInfo.fromJSON(object.linear) }
        : isSet(object.jira)
        ? { $case: "jira", value: JiraDocumentLinkInfo.fromJSON(object.jira) }
        : undefined,
    };
  },

  toJSON(message: LinkedDocumentInfo): unknown {
    const obj: any = {};
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.externalId !== undefined) {
      obj.externalId = ExternalId.toJSON(message.externalId);
    }
    if (message.data?.$case === "linear") {
      obj.linear = LinearDocumentLinkInfo.toJSON(message.data.value);
    } else if (message.data?.$case === "jira") {
      obj.jira = JiraDocumentLinkInfo.toJSON(message.data.value);
    }
    return obj;
  },

  create(base?: DeepPartial<LinkedDocumentInfo>): LinkedDocumentInfo {
    return LinkedDocumentInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LinkedDocumentInfo>): LinkedDocumentInfo {
    const message = createBaseLinkedDocumentInfo();
    message.documentId = object.documentId ?? "";
    message.companyId = object.companyId ?? 0;
    message.externalId = (object.externalId !== undefined && object.externalId !== null)
      ? ExternalId.fromPartial(object.externalId)
      : undefined;
    switch (object.data?.$case) {
      case "linear": {
        if (object.data?.value !== undefined && object.data?.value !== null) {
          message.data = { $case: "linear", value: LinearDocumentLinkInfo.fromPartial(object.data.value) };
        }
        break;
      }
      case "jira": {
        if (object.data?.value !== undefined && object.data?.value !== null) {
          message.data = { $case: "jira", value: JiraDocumentLinkInfo.fromPartial(object.data.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseLinearDocumentLinkInfo(): LinearDocumentLinkInfo {
  return { info: undefined };
}

export const LinearDocumentLinkInfo: MessageFns<LinearDocumentLinkInfo> = {
  encode(message: LinearDocumentLinkInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.info?.$case) {
      case "issue":
        LinearIssue.encode(message.info.value, writer.uint32(10).fork()).join();
        break;
      case "project":
        LinearProject.encode(message.info.value, writer.uint32(18).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinearDocumentLinkInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinearDocumentLinkInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = { $case: "issue", value: LinearIssue.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.info = { $case: "project", value: LinearProject.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinearDocumentLinkInfo {
    return {
      info: isSet(object.issue)
        ? { $case: "issue", value: LinearIssue.fromJSON(object.issue) }
        : isSet(object.project)
        ? { $case: "project", value: LinearProject.fromJSON(object.project) }
        : undefined,
    };
  },

  toJSON(message: LinearDocumentLinkInfo): unknown {
    const obj: any = {};
    if (message.info?.$case === "issue") {
      obj.issue = LinearIssue.toJSON(message.info.value);
    } else if (message.info?.$case === "project") {
      obj.project = LinearProject.toJSON(message.info.value);
    }
    return obj;
  },

  create(base?: DeepPartial<LinearDocumentLinkInfo>): LinearDocumentLinkInfo {
    return LinearDocumentLinkInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LinearDocumentLinkInfo>): LinearDocumentLinkInfo {
    const message = createBaseLinearDocumentLinkInfo();
    switch (object.info?.$case) {
      case "issue": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "issue", value: LinearIssue.fromPartial(object.info.value) };
        }
        break;
      }
      case "project": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "project", value: LinearProject.fromPartial(object.info.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseJiraDocumentLinkInfo(): JiraDocumentLinkInfo {
  return { info: undefined };
}

export const JiraDocumentLinkInfo: MessageFns<JiraDocumentLinkInfo> = {
  encode(message: JiraDocumentLinkInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.info?.$case) {
      case "issue":
        JiraIssue.encode(message.info.value, writer.uint32(10).fork()).join();
        break;
      case "epic":
        JiraProject.encode(message.info.value, writer.uint32(18).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraDocumentLinkInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraDocumentLinkInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = { $case: "issue", value: JiraIssue.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.info = { $case: "epic", value: JiraProject.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraDocumentLinkInfo {
    return {
      info: isSet(object.issue)
        ? { $case: "issue", value: JiraIssue.fromJSON(object.issue) }
        : isSet(object.epic)
        ? { $case: "epic", value: JiraProject.fromJSON(object.epic) }
        : undefined,
    };
  },

  toJSON(message: JiraDocumentLinkInfo): unknown {
    const obj: any = {};
    if (message.info?.$case === "issue") {
      obj.issue = JiraIssue.toJSON(message.info.value);
    } else if (message.info?.$case === "epic") {
      obj.epic = JiraProject.toJSON(message.info.value);
    }
    return obj;
  },

  create(base?: DeepPartial<JiraDocumentLinkInfo>): JiraDocumentLinkInfo {
    return JiraDocumentLinkInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraDocumentLinkInfo>): JiraDocumentLinkInfo {
    const message = createBaseJiraDocumentLinkInfo();
    switch (object.info?.$case) {
      case "issue": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "issue", value: JiraIssue.fromPartial(object.info.value) };
        }
        break;
      }
      case "epic": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "epic", value: JiraProject.fromPartial(object.info.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseIntegrationInfo(): IntegrationInfo {
  return { info: undefined };
}

export const IntegrationInfo: MessageFns<IntegrationInfo> = {
  encode(message: IntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.info?.$case) {
      case "linear":
        LinearIntegrationInfo.encode(message.info.value, writer.uint32(10).fork()).join();
        break;
      case "github":
        GitHubIntegrationInfo.encode(message.info.value, writer.uint32(18).fork()).join();
        break;
      case "jira":
        JiraIntegrationInfo.encode(message.info.value, writer.uint32(26).fork()).join();
        break;
      case "bitBucket":
        BitBucketIntegrationInfo.encode(message.info.value, writer.uint32(34).fork()).join();
        break;
      case "slack":
        SlackIntegrationInfo.encode(message.info.value, writer.uint32(42).fork()).join();
        break;
      case "notion":
        NotionIntegrationInfo.encode(message.info.value, writer.uint32(50).fork()).join();
        break;
      case "confluence":
        ConfluenceIntegrationInfo.encode(message.info.value, writer.uint32(58).fork()).join();
        break;
      case "teams":
        TeamsIntegrationInfo.encode(message.info.value, writer.uint32(66).fork()).join();
        break;
      case "gitlab":
        GitLabIntegrationInfo.encode(message.info.value, writer.uint32(74).fork()).join();
        break;
      case "zoom":
        ZoomIntegrationInfo.encode(message.info.value, writer.uint32(82).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = { $case: "linear", value: LinearIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.info = { $case: "github", value: GitHubIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.info = { $case: "jira", value: JiraIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.info = { $case: "bitBucket", value: BitBucketIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.info = { $case: "slack", value: SlackIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.info = { $case: "notion", value: NotionIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.info = { $case: "confluence", value: ConfluenceIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.info = { $case: "teams", value: TeamsIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.info = { $case: "gitlab", value: GitLabIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.info = { $case: "zoom", value: ZoomIntegrationInfo.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationInfo {
    return {
      info: isSet(object.linear)
        ? { $case: "linear", value: LinearIntegrationInfo.fromJSON(object.linear) }
        : isSet(object.github)
        ? { $case: "github", value: GitHubIntegrationInfo.fromJSON(object.github) }
        : isSet(object.jira)
        ? { $case: "jira", value: JiraIntegrationInfo.fromJSON(object.jira) }
        : isSet(object.bitBucket)
        ? { $case: "bitBucket", value: BitBucketIntegrationInfo.fromJSON(object.bitBucket) }
        : isSet(object.bit_bucket)
        ? { $case: "bitBucket", value: BitBucketIntegrationInfo.fromJSON(object.bit_bucket) }
        : isSet(object.slack)
        ? { $case: "slack", value: SlackIntegrationInfo.fromJSON(object.slack) }
        : isSet(object.notion)
        ? { $case: "notion", value: NotionIntegrationInfo.fromJSON(object.notion) }
        : isSet(object.confluence)
        ? { $case: "confluence", value: ConfluenceIntegrationInfo.fromJSON(object.confluence) }
        : isSet(object.teams)
        ? { $case: "teams", value: TeamsIntegrationInfo.fromJSON(object.teams) }
        : isSet(object.gitlab)
        ? { $case: "gitlab", value: GitLabIntegrationInfo.fromJSON(object.gitlab) }
        : isSet(object.zoom)
        ? { $case: "zoom", value: ZoomIntegrationInfo.fromJSON(object.zoom) }
        : undefined,
    };
  },

  toJSON(message: IntegrationInfo): unknown {
    const obj: any = {};
    if (message.info?.$case === "linear") {
      obj.linear = LinearIntegrationInfo.toJSON(message.info.value);
    } else if (message.info?.$case === "github") {
      obj.github = GitHubIntegrationInfo.toJSON(message.info.value);
    } else if (message.info?.$case === "jira") {
      obj.jira = JiraIntegrationInfo.toJSON(message.info.value);
    } else if (message.info?.$case === "bitBucket") {
      obj.bitBucket = BitBucketIntegrationInfo.toJSON(message.info.value);
    } else if (message.info?.$case === "slack") {
      obj.slack = SlackIntegrationInfo.toJSON(message.info.value);
    } else if (message.info?.$case === "notion") {
      obj.notion = NotionIntegrationInfo.toJSON(message.info.value);
    } else if (message.info?.$case === "confluence") {
      obj.confluence = ConfluenceIntegrationInfo.toJSON(message.info.value);
    } else if (message.info?.$case === "teams") {
      obj.teams = TeamsIntegrationInfo.toJSON(message.info.value);
    } else if (message.info?.$case === "gitlab") {
      obj.gitlab = GitLabIntegrationInfo.toJSON(message.info.value);
    } else if (message.info?.$case === "zoom") {
      obj.zoom = ZoomIntegrationInfo.toJSON(message.info.value);
    }
    return obj;
  },

  create(base?: DeepPartial<IntegrationInfo>): IntegrationInfo {
    return IntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntegrationInfo>): IntegrationInfo {
    const message = createBaseIntegrationInfo();
    switch (object.info?.$case) {
      case "linear": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "linear", value: LinearIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
      case "github": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "github", value: GitHubIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
      case "jira": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "jira", value: JiraIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
      case "bitBucket": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "bitBucket", value: BitBucketIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
      case "slack": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "slack", value: SlackIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
      case "notion": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "notion", value: NotionIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
      case "confluence": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "confluence", value: ConfluenceIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
      case "teams": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "teams", value: TeamsIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
      case "gitlab": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "gitlab", value: GitLabIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
      case "zoom": {
        if (object.info?.value !== undefined && object.info?.value !== null) {
          message.info = { $case: "zoom", value: ZoomIntegrationInfo.fromPartial(object.info.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseZoomIntegrationInfo(): ZoomIntegrationInfo {
  return { accountId: "", userId: "", email: "" };
}

export const ZoomIntegrationInfo: MessageFns<ZoomIntegrationInfo> = {
  encode(message: ZoomIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.email !== "") {
      writer.uint32(26).string(message.email);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ZoomIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseZoomIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.email = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ZoomIntegrationInfo {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
        ? globalThis.String(object.account_id)
        : "",
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
    };
  },

  toJSON(message: ZoomIntegrationInfo): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    return obj;
  },

  create(base?: DeepPartial<ZoomIntegrationInfo>): ZoomIntegrationInfo {
    return ZoomIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ZoomIntegrationInfo>): ZoomIntegrationInfo {
    const message = createBaseZoomIntegrationInfo();
    message.accountId = object.accountId ?? "";
    message.userId = object.userId ?? "";
    message.email = object.email ?? "";
    return message;
  },
};

function createBaseLinearIssue(): LinearIssue {
  return { id: "", teamId: "", identifier: "", url: "" };
}

export const LinearIssue: MessageFns<LinearIssue> = {
  encode(message: LinearIssue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.teamId !== "") {
      writer.uint32(18).string(message.teamId);
    }
    if (message.identifier !== "") {
      writer.uint32(26).string(message.identifier);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinearIssue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinearIssue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.teamId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.identifier = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinearIssue {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      teamId: isSet(object.teamId)
        ? globalThis.String(object.teamId)
        : isSet(object.team_id)
        ? globalThis.String(object.team_id)
        : "",
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: LinearIssue): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.teamId !== "") {
      obj.teamId = message.teamId;
    }
    if (message.identifier !== "") {
      obj.identifier = message.identifier;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<LinearIssue>): LinearIssue {
    return LinearIssue.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LinearIssue>): LinearIssue {
    const message = createBaseLinearIssue();
    message.id = object.id ?? "";
    message.teamId = object.teamId ?? "";
    message.identifier = object.identifier ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseLinearProject(): LinearProject {
  return { id: "", url: "" };
}

export const LinearProject: MessageFns<LinearProject> = {
  encode(message: LinearProject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinearProject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinearProject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinearProject {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: LinearProject): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<LinearProject>): LinearProject {
    return LinearProject.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LinearProject>): LinearProject {
    const message = createBaseLinearProject();
    message.id = object.id ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseLinearOrganization(): LinearOrganization {
  return { id: "", name: "", urlKey: "" };
}

export const LinearOrganization: MessageFns<LinearOrganization> = {
  encode(message: LinearOrganization, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.urlKey !== "") {
      writer.uint32(26).string(message.urlKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinearOrganization {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinearOrganization();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.urlKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinearOrganization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      urlKey: isSet(object.urlKey)
        ? globalThis.String(object.urlKey)
        : isSet(object.url_key)
        ? globalThis.String(object.url_key)
        : "",
    };
  },

  toJSON(message: LinearOrganization): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.urlKey !== "") {
      obj.urlKey = message.urlKey;
    }
    return obj;
  },

  create(base?: DeepPartial<LinearOrganization>): LinearOrganization {
    return LinearOrganization.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LinearOrganization>): LinearOrganization {
    const message = createBaseLinearOrganization();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.urlKey = object.urlKey ?? "";
    return message;
  },
};

function createBaseLinearTeam(): LinearTeam {
  return { id: "", name: "", key: "" };
}

export const LinearTeam: MessageFns<LinearTeam> = {
  encode(message: LinearTeam, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.key !== "") {
      writer.uint32(26).string(message.key);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinearTeam {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinearTeam();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.key = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinearTeam {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      key: isSet(object.key) ? globalThis.String(object.key) : "",
    };
  },

  toJSON(message: LinearTeam): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.key !== "") {
      obj.key = message.key;
    }
    return obj;
  },

  create(base?: DeepPartial<LinearTeam>): LinearTeam {
    return LinearTeam.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LinearTeam>): LinearTeam {
    const message = createBaseLinearTeam();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.key = object.key ?? "";
    return message;
  },
};

function createBaseLinearIntegrationInfo(): LinearIntegrationInfo {
  return { organization: undefined, teams: [] };
}

export const LinearIntegrationInfo: MessageFns<LinearIntegrationInfo> = {
  encode(message: LinearIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.organization !== undefined) {
      LinearOrganization.encode(message.organization, writer.uint32(10).fork()).join();
    }
    for (const v of message.teams) {
      LinearTeam.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinearIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinearIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.organization = LinearOrganization.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.teams.push(LinearTeam.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinearIntegrationInfo {
    return {
      organization: isSet(object.organization) ? LinearOrganization.fromJSON(object.organization) : undefined,
      teams: globalThis.Array.isArray(object?.teams) ? object.teams.map((e: any) => LinearTeam.fromJSON(e)) : [],
    };
  },

  toJSON(message: LinearIntegrationInfo): unknown {
    const obj: any = {};
    if (message.organization !== undefined) {
      obj.organization = LinearOrganization.toJSON(message.organization);
    }
    if (message.teams?.length) {
      obj.teams = message.teams.map((e) => LinearTeam.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<LinearIntegrationInfo>): LinearIntegrationInfo {
    return LinearIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LinearIntegrationInfo>): LinearIntegrationInfo {
    const message = createBaseLinearIntegrationInfo();
    message.organization = (object.organization !== undefined && object.organization !== null)
      ? LinearOrganization.fromPartial(object.organization)
      : undefined;
    message.teams = object.teams?.map((e) => LinearTeam.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGitRepository(): GitRepository {
  return { id: "", name: "", fullName: "", url: "", description: "", provider: 0 };
}

export const GitRepository: MessageFns<GitRepository> = {
  encode(message: GitRepository, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.fullName !== "") {
      writer.uint32(26).string(message.fullName);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    if (message.description !== "") {
      writer.uint32(42).string(message.description);
    }
    if (message.provider !== 0) {
      writer.uint32(48).int32(message.provider);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GitRepository {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGitRepository();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fullName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GitRepository {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      fullName: isSet(object.fullName)
        ? globalThis.String(object.fullName)
        : isSet(object.full_name)
        ? globalThis.String(object.full_name)
        : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      provider: isSet(object.provider) ? gitProviderFromJSON(object.provider) : 0,
    };
  },

  toJSON(message: GitRepository): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.fullName !== "") {
      obj.fullName = message.fullName;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.provider !== 0) {
      obj.provider = gitProviderToJSON(message.provider);
    }
    return obj;
  },

  create(base?: DeepPartial<GitRepository>): GitRepository {
    return GitRepository.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GitRepository>): GitRepository {
    const message = createBaseGitRepository();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.fullName = object.fullName ?? "";
    message.url = object.url ?? "";
    message.description = object.description ?? "";
    message.provider = object.provider ?? 0;
    return message;
  },
};

function createBaseGitHubOrganization(): GitHubOrganization {
  return { id: "", name: "", url: "" };
}

export const GitHubOrganization: MessageFns<GitHubOrganization> = {
  encode(message: GitHubOrganization, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.url !== "") {
      writer.uint32(26).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GitHubOrganization {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGitHubOrganization();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GitHubOrganization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: GitHubOrganization): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<GitHubOrganization>): GitHubOrganization {
    return GitHubOrganization.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GitHubOrganization>): GitHubOrganization {
    const message = createBaseGitHubOrganization();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseGitHubIntegrationInfo(): GitHubIntegrationInfo {
  return { organization: undefined, repositories: [] };
}

export const GitHubIntegrationInfo: MessageFns<GitHubIntegrationInfo> = {
  encode(message: GitHubIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.organization !== undefined) {
      GitHubOrganization.encode(message.organization, writer.uint32(10).fork()).join();
    }
    for (const v of message.repositories) {
      GitRepository.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GitHubIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGitHubIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.organization = GitHubOrganization.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.repositories.push(GitRepository.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GitHubIntegrationInfo {
    return {
      organization: isSet(object.organization) ? GitHubOrganization.fromJSON(object.organization) : undefined,
      repositories: globalThis.Array.isArray(object?.repositories)
        ? object.repositories.map((e: any) => GitRepository.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GitHubIntegrationInfo): unknown {
    const obj: any = {};
    if (message.organization !== undefined) {
      obj.organization = GitHubOrganization.toJSON(message.organization);
    }
    if (message.repositories?.length) {
      obj.repositories = message.repositories.map((e) => GitRepository.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GitHubIntegrationInfo>): GitHubIntegrationInfo {
    return GitHubIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GitHubIntegrationInfo>): GitHubIntegrationInfo {
    const message = createBaseGitHubIntegrationInfo();
    message.organization = (object.organization !== undefined && object.organization !== null)
      ? GitHubOrganization.fromPartial(object.organization)
      : undefined;
    message.repositories = object.repositories?.map((e) => GitRepository.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBitBucketIntegrationInfo(): BitBucketIntegrationInfo {
  return { integrations: [], availableWorkspaces: [] };
}

export const BitBucketIntegrationInfo: MessageFns<BitBucketIntegrationInfo> = {
  encode(message: BitBucketIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.integrations) {
      BitBucketWorkspaceIntegration.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.availableWorkspaces) {
      BitBucketWorkspace.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BitBucketIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBitBucketIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.integrations.push(BitBucketWorkspaceIntegration.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.availableWorkspaces.push(BitBucketWorkspace.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BitBucketIntegrationInfo {
    return {
      integrations: globalThis.Array.isArray(object?.integrations)
        ? object.integrations.map((e: any) => BitBucketWorkspaceIntegration.fromJSON(e))
        : [],
      availableWorkspaces: globalThis.Array.isArray(object?.availableWorkspaces)
        ? object.availableWorkspaces.map((e: any) => BitBucketWorkspace.fromJSON(e))
        : globalThis.Array.isArray(object?.available_workspaces)
        ? object.available_workspaces.map((e: any) => BitBucketWorkspace.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BitBucketIntegrationInfo): unknown {
    const obj: any = {};
    if (message.integrations?.length) {
      obj.integrations = message.integrations.map((e) => BitBucketWorkspaceIntegration.toJSON(e));
    }
    if (message.availableWorkspaces?.length) {
      obj.availableWorkspaces = message.availableWorkspaces.map((e) => BitBucketWorkspace.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<BitBucketIntegrationInfo>): BitBucketIntegrationInfo {
    return BitBucketIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BitBucketIntegrationInfo>): BitBucketIntegrationInfo {
    const message = createBaseBitBucketIntegrationInfo();
    message.integrations = object.integrations?.map((e) => BitBucketWorkspaceIntegration.fromPartial(e)) || [];
    message.availableWorkspaces = object.availableWorkspaces?.map((e) => BitBucketWorkspace.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBitBucketWorkspaceIntegration(): BitBucketWorkspaceIntegration {
  return { workspace: undefined, repositories: [] };
}

export const BitBucketWorkspaceIntegration: MessageFns<BitBucketWorkspaceIntegration> = {
  encode(message: BitBucketWorkspaceIntegration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workspace !== undefined) {
      BitBucketWorkspace.encode(message.workspace, writer.uint32(10).fork()).join();
    }
    for (const v of message.repositories) {
      GitRepository.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BitBucketWorkspaceIntegration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBitBucketWorkspaceIntegration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workspace = BitBucketWorkspace.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.repositories.push(GitRepository.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BitBucketWorkspaceIntegration {
    return {
      workspace: isSet(object.workspace) ? BitBucketWorkspace.fromJSON(object.workspace) : undefined,
      repositories: globalThis.Array.isArray(object?.repositories)
        ? object.repositories.map((e: any) => GitRepository.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BitBucketWorkspaceIntegration): unknown {
    const obj: any = {};
    if (message.workspace !== undefined) {
      obj.workspace = BitBucketWorkspace.toJSON(message.workspace);
    }
    if (message.repositories?.length) {
      obj.repositories = message.repositories.map((e) => GitRepository.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<BitBucketWorkspaceIntegration>): BitBucketWorkspaceIntegration {
    return BitBucketWorkspaceIntegration.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BitBucketWorkspaceIntegration>): BitBucketWorkspaceIntegration {
    const message = createBaseBitBucketWorkspaceIntegration();
    message.workspace = (object.workspace !== undefined && object.workspace !== null)
      ? BitBucketWorkspace.fromPartial(object.workspace)
      : undefined;
    message.repositories = object.repositories?.map((e) => GitRepository.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBitBucketWorkspace(): BitBucketWorkspace {
  return { uuid: "", name: undefined, slug: "", url: "" };
}

export const BitBucketWorkspace: MessageFns<BitBucketWorkspace> = {
  encode(message: BitBucketWorkspace, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.slug !== "") {
      writer.uint32(26).string(message.slug);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BitBucketWorkspace {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBitBucketWorkspace();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.slug = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BitBucketWorkspace {
    return {
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: BitBucketWorkspace): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.slug !== "") {
      obj.slug = message.slug;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<BitBucketWorkspace>): BitBucketWorkspace {
    return BitBucketWorkspace.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BitBucketWorkspace>): BitBucketWorkspace {
    const message = createBaseBitBucketWorkspace();
    message.uuid = object.uuid ?? "";
    message.name = object.name ?? undefined;
    message.slug = object.slug ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseGitLabIntegrationInfo(): GitLabIntegrationInfo {
  return {
    repositories: [],
    tokenAccess: undefined,
    repositoryDiscovery: undefined,
    tokenRotation: undefined,
    connectedAt: undefined,
  };
}

export const GitLabIntegrationInfo: MessageFns<GitLabIntegrationInfo> = {
  encode(message: GitLabIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.repositories) {
      GitRepository.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.tokenAccess !== undefined) {
      GitLabTokenAccessState.encode(message.tokenAccess, writer.uint32(18).fork()).join();
    }
    if (message.repositoryDiscovery !== undefined) {
      GitLabRepositoryDiscoveryState.encode(message.repositoryDiscovery, writer.uint32(26).fork()).join();
    }
    if (message.tokenRotation !== undefined) {
      GitLabTokenRotationState.encode(message.tokenRotation, writer.uint32(34).fork()).join();
    }
    if (message.connectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.connectedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GitLabIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGitLabIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repositories.push(GitRepository.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tokenAccess = GitLabTokenAccessState.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.repositoryDiscovery = GitLabRepositoryDiscoveryState.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tokenRotation = GitLabTokenRotationState.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.connectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GitLabIntegrationInfo {
    return {
      repositories: globalThis.Array.isArray(object?.repositories)
        ? object.repositories.map((e: any) => GitRepository.fromJSON(e))
        : [],
      tokenAccess: isSet(object.tokenAccess)
        ? GitLabTokenAccessState.fromJSON(object.tokenAccess)
        : isSet(object.token_access)
        ? GitLabTokenAccessState.fromJSON(object.token_access)
        : undefined,
      repositoryDiscovery: isSet(object.repositoryDiscovery)
        ? GitLabRepositoryDiscoveryState.fromJSON(object.repositoryDiscovery)
        : isSet(object.repository_discovery)
        ? GitLabRepositoryDiscoveryState.fromJSON(object.repository_discovery)
        : undefined,
      tokenRotation: isSet(object.tokenRotation)
        ? GitLabTokenRotationState.fromJSON(object.tokenRotation)
        : isSet(object.token_rotation)
        ? GitLabTokenRotationState.fromJSON(object.token_rotation)
        : undefined,
      connectedAt: isSet(object.connectedAt)
        ? fromJsonTimestamp(object.connectedAt)
        : isSet(object.connected_at)
        ? fromJsonTimestamp(object.connected_at)
        : undefined,
    };
  },

  toJSON(message: GitLabIntegrationInfo): unknown {
    const obj: any = {};
    if (message.repositories?.length) {
      obj.repositories = message.repositories.map((e) => GitRepository.toJSON(e));
    }
    if (message.tokenAccess !== undefined) {
      obj.tokenAccess = GitLabTokenAccessState.toJSON(message.tokenAccess);
    }
    if (message.repositoryDiscovery !== undefined) {
      obj.repositoryDiscovery = GitLabRepositoryDiscoveryState.toJSON(message.repositoryDiscovery);
    }
    if (message.tokenRotation !== undefined) {
      obj.tokenRotation = GitLabTokenRotationState.toJSON(message.tokenRotation);
    }
    if (message.connectedAt !== undefined) {
      obj.connectedAt = message.connectedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<GitLabIntegrationInfo>): GitLabIntegrationInfo {
    return GitLabIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GitLabIntegrationInfo>): GitLabIntegrationInfo {
    const message = createBaseGitLabIntegrationInfo();
    message.repositories = object.repositories?.map((e) => GitRepository.fromPartial(e)) || [];
    message.tokenAccess = (object.tokenAccess !== undefined && object.tokenAccess !== null)
      ? GitLabTokenAccessState.fromPartial(object.tokenAccess)
      : undefined;
    message.repositoryDiscovery = (object.repositoryDiscovery !== undefined && object.repositoryDiscovery !== null)
      ? GitLabRepositoryDiscoveryState.fromPartial(object.repositoryDiscovery)
      : undefined;
    message.tokenRotation = (object.tokenRotation !== undefined && object.tokenRotation !== null)
      ? GitLabTokenRotationState.fromPartial(object.tokenRotation)
      : undefined;
    message.connectedAt = object.connectedAt ?? undefined;
    return message;
  },
};

function createBaseGitLabTokenAccessState(): GitLabTokenAccessState {
  return { status: 0, errorMessage: "", tokenExpiresAt: undefined };
}

export const GitLabTokenAccessState: MessageFns<GitLabTokenAccessState> = {
  encode(message: GitLabTokenAccessState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.errorMessage !== "") {
      writer.uint32(18).string(message.errorMessage);
    }
    if (message.tokenExpiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.tokenExpiresAt), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GitLabTokenAccessState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGitLabTokenAccessState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tokenExpiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GitLabTokenAccessState {
    return {
      status: isSet(object.status) ? gitLabTokenAccessStatusFromJSON(object.status) : 0,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
        ? globalThis.String(object.error_message)
        : "",
      tokenExpiresAt: isSet(object.tokenExpiresAt)
        ? fromJsonTimestamp(object.tokenExpiresAt)
        : isSet(object.token_expires_at)
        ? fromJsonTimestamp(object.token_expires_at)
        : undefined,
    };
  },

  toJSON(message: GitLabTokenAccessState): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = gitLabTokenAccessStatusToJSON(message.status);
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    if (message.tokenExpiresAt !== undefined) {
      obj.tokenExpiresAt = message.tokenExpiresAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<GitLabTokenAccessState>): GitLabTokenAccessState {
    return GitLabTokenAccessState.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GitLabTokenAccessState>): GitLabTokenAccessState {
    const message = createBaseGitLabTokenAccessState();
    message.status = object.status ?? 0;
    message.errorMessage = object.errorMessage ?? "";
    message.tokenExpiresAt = object.tokenExpiresAt ?? undefined;
    return message;
  },
};

function createBaseGitLabRepositoryDiscoveryState(): GitLabRepositoryDiscoveryState {
  return { status: 0, errorMessage: "", lastSuccessfulAt: undefined };
}

export const GitLabRepositoryDiscoveryState: MessageFns<GitLabRepositoryDiscoveryState> = {
  encode(message: GitLabRepositoryDiscoveryState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.errorMessage !== "") {
      writer.uint32(18).string(message.errorMessage);
    }
    if (message.lastSuccessfulAt !== undefined) {
      Timestamp.encode(toTimestamp(message.lastSuccessfulAt), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GitLabRepositoryDiscoveryState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGitLabRepositoryDiscoveryState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastSuccessfulAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GitLabRepositoryDiscoveryState {
    return {
      status: isSet(object.status) ? gitLabRepositoryDiscoveryStatusFromJSON(object.status) : 0,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
        ? globalThis.String(object.error_message)
        : "",
      lastSuccessfulAt: isSet(object.lastSuccessfulAt)
        ? fromJsonTimestamp(object.lastSuccessfulAt)
        : isSet(object.last_successful_at)
        ? fromJsonTimestamp(object.last_successful_at)
        : undefined,
    };
  },

  toJSON(message: GitLabRepositoryDiscoveryState): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = gitLabRepositoryDiscoveryStatusToJSON(message.status);
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    if (message.lastSuccessfulAt !== undefined) {
      obj.lastSuccessfulAt = message.lastSuccessfulAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<GitLabRepositoryDiscoveryState>): GitLabRepositoryDiscoveryState {
    return GitLabRepositoryDiscoveryState.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GitLabRepositoryDiscoveryState>): GitLabRepositoryDiscoveryState {
    const message = createBaseGitLabRepositoryDiscoveryState();
    message.status = object.status ?? 0;
    message.errorMessage = object.errorMessage ?? "";
    message.lastSuccessfulAt = object.lastSuccessfulAt ?? undefined;
    return message;
  },
};

function createBaseGitLabTokenRotationState(): GitLabTokenRotationState {
  return { status: 0, errorMessage: "", nextRotationAt: undefined };
}

export const GitLabTokenRotationState: MessageFns<GitLabTokenRotationState> = {
  encode(message: GitLabTokenRotationState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.errorMessage !== "") {
      writer.uint32(18).string(message.errorMessage);
    }
    if (message.nextRotationAt !== undefined) {
      Timestamp.encode(toTimestamp(message.nextRotationAt), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GitLabTokenRotationState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGitLabTokenRotationState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nextRotationAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GitLabTokenRotationState {
    return {
      status: isSet(object.status) ? gitLabTokenRotationStatusFromJSON(object.status) : 0,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
        ? globalThis.String(object.error_message)
        : "",
      nextRotationAt: isSet(object.nextRotationAt)
        ? fromJsonTimestamp(object.nextRotationAt)
        : isSet(object.next_rotation_at)
        ? fromJsonTimestamp(object.next_rotation_at)
        : undefined,
    };
  },

  toJSON(message: GitLabTokenRotationState): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = gitLabTokenRotationStatusToJSON(message.status);
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    if (message.nextRotationAt !== undefined) {
      obj.nextRotationAt = message.nextRotationAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<GitLabTokenRotationState>): GitLabTokenRotationState {
    return GitLabTokenRotationState.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GitLabTokenRotationState>): GitLabTokenRotationState {
    const message = createBaseGitLabTokenRotationState();
    message.status = object.status ?? 0;
    message.errorMessage = object.errorMessage ?? "";
    message.nextRotationAt = object.nextRotationAt ?? undefined;
    return message;
  },
};

function createBaseJiraOrganization(): JiraOrganization {
  return { id: "", name: "", url: "" };
}

export const JiraOrganization: MessageFns<JiraOrganization> = {
  encode(message: JiraOrganization, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraOrganization {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraOrganization();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraOrganization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: JiraOrganization): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<JiraOrganization>): JiraOrganization {
    return JiraOrganization.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraOrganization>): JiraOrganization {
    const message = createBaseJiraOrganization();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseJiraTeam(): JiraTeam {
  return { id: "", name: "", key: "" };
}

export const JiraTeam: MessageFns<JiraTeam> = {
  encode(message: JiraTeam, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.key !== "") {
      writer.uint32(26).string(message.key);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraTeam {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraTeam();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.key = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraTeam {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      key: isSet(object.key) ? globalThis.String(object.key) : "",
    };
  },

  toJSON(message: JiraTeam): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.key !== "") {
      obj.key = message.key;
    }
    return obj;
  },

  create(base?: DeepPartial<JiraTeam>): JiraTeam {
    return JiraTeam.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraTeam>): JiraTeam {
    const message = createBaseJiraTeam();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.key = object.key ?? "";
    return message;
  },
};

function createBaseJiraIntegrationInfo(): JiraIntegrationInfo {
  return { organization: undefined, teams: [] };
}

export const JiraIntegrationInfo: MessageFns<JiraIntegrationInfo> = {
  encode(message: JiraIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.organization !== undefined) {
      JiraOrganization.encode(message.organization, writer.uint32(10).fork()).join();
    }
    for (const v of message.teams) {
      JiraTeam.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.organization = JiraOrganization.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.teams.push(JiraTeam.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraIntegrationInfo {
    return {
      organization: isSet(object.organization) ? JiraOrganization.fromJSON(object.organization) : undefined,
      teams: globalThis.Array.isArray(object?.teams) ? object.teams.map((e: any) => JiraTeam.fromJSON(e)) : [],
    };
  },

  toJSON(message: JiraIntegrationInfo): unknown {
    const obj: any = {};
    if (message.organization !== undefined) {
      obj.organization = JiraOrganization.toJSON(message.organization);
    }
    if (message.teams?.length) {
      obj.teams = message.teams.map((e) => JiraTeam.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<JiraIntegrationInfo>): JiraIntegrationInfo {
    return JiraIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraIntegrationInfo>): JiraIntegrationInfo {
    const message = createBaseJiraIntegrationInfo();
    message.organization = (object.organization !== undefined && object.organization !== null)
      ? JiraOrganization.fromPartial(object.organization)
      : undefined;
    message.teams = object.teams?.map((e) => JiraTeam.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJiraIssue(): JiraIssue {
  return { id: "", teamId: "", identifier: "", url: "" };
}

export const JiraIssue: MessageFns<JiraIssue> = {
  encode(message: JiraIssue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.teamId !== "") {
      writer.uint32(18).string(message.teamId);
    }
    if (message.identifier !== "") {
      writer.uint32(26).string(message.identifier);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraIssue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraIssue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.teamId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.identifier = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraIssue {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      teamId: isSet(object.teamId)
        ? globalThis.String(object.teamId)
        : isSet(object.team_id)
        ? globalThis.String(object.team_id)
        : "",
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: JiraIssue): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.teamId !== "") {
      obj.teamId = message.teamId;
    }
    if (message.identifier !== "") {
      obj.identifier = message.identifier;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<JiraIssue>): JiraIssue {
    return JiraIssue.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraIssue>): JiraIssue {
    const message = createBaseJiraIssue();
    message.id = object.id ?? "";
    message.teamId = object.teamId ?? "";
    message.identifier = object.identifier ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseJiraProject(): JiraProject {
  return { id: "", key: "", url: "", teamId: "" };
}

export const JiraProject: MessageFns<JiraProject> = {
  encode(message: JiraProject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.key !== "") {
      writer.uint32(18).string(message.key);
    }
    if (message.url !== "") {
      writer.uint32(26).string(message.url);
    }
    if (message.teamId !== "") {
      writer.uint32(34).string(message.teamId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraProject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraProject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.teamId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraProject {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      teamId: isSet(object.teamId)
        ? globalThis.String(object.teamId)
        : isSet(object.team_id)
        ? globalThis.String(object.team_id)
        : "",
    };
  },

  toJSON(message: JiraProject): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.teamId !== "") {
      obj.teamId = message.teamId;
    }
    return obj;
  },

  create(base?: DeepPartial<JiraProject>): JiraProject {
    return JiraProject.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraProject>): JiraProject {
    const message = createBaseJiraProject();
    message.id = object.id ?? "";
    message.key = object.key ?? "";
    message.url = object.url ?? "";
    message.teamId = object.teamId ?? "";
    return message;
  },
};

function createBaseIntegrationProperties(): IntegrationProperties {
  return { linear: undefined, github: undefined, jira: undefined };
}

export const IntegrationProperties: MessageFns<IntegrationProperties> = {
  encode(message: IntegrationProperties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.linear !== undefined) {
      LinearIntegrationProperties.encode(message.linear, writer.uint32(10).fork()).join();
    }
    if (message.github !== undefined) {
      GitHubIntegrationProperties.encode(message.github, writer.uint32(18).fork()).join();
    }
    if (message.jira !== undefined) {
      JiraIntegrationProperties.encode(message.jira, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationProperties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationProperties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.linear = LinearIntegrationProperties.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.github = GitHubIntegrationProperties.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.jira = JiraIntegrationProperties.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationProperties {
    return {
      linear: isSet(object.linear) ? LinearIntegrationProperties.fromJSON(object.linear) : undefined,
      github: isSet(object.github) ? GitHubIntegrationProperties.fromJSON(object.github) : undefined,
      jira: isSet(object.jira) ? JiraIntegrationProperties.fromJSON(object.jira) : undefined,
    };
  },

  toJSON(message: IntegrationProperties): unknown {
    const obj: any = {};
    if (message.linear !== undefined) {
      obj.linear = LinearIntegrationProperties.toJSON(message.linear);
    }
    if (message.github !== undefined) {
      obj.github = GitHubIntegrationProperties.toJSON(message.github);
    }
    if (message.jira !== undefined) {
      obj.jira = JiraIntegrationProperties.toJSON(message.jira);
    }
    return obj;
  },

  create(base?: DeepPartial<IntegrationProperties>): IntegrationProperties {
    return IntegrationProperties.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntegrationProperties>): IntegrationProperties {
    const message = createBaseIntegrationProperties();
    message.linear = (object.linear !== undefined && object.linear !== null)
      ? LinearIntegrationProperties.fromPartial(object.linear)
      : undefined;
    message.github = (object.github !== undefined && object.github !== null)
      ? GitHubIntegrationProperties.fromPartial(object.github)
      : undefined;
    message.jira = (object.jira !== undefined && object.jira !== null)
      ? JiraIntegrationProperties.fromPartial(object.jira)
      : undefined;
    return message;
  },
};

function createBaseLinearIntegrationProperties(): LinearIntegrationProperties {
  return { noLinkBack: false, includePrompts: false, excludeUserStoryPrompts: false };
}

export const LinearIntegrationProperties: MessageFns<LinearIntegrationProperties> = {
  encode(message: LinearIntegrationProperties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.noLinkBack !== false) {
      writer.uint32(8).bool(message.noLinkBack);
    }
    if (message.includePrompts !== false) {
      writer.uint32(16).bool(message.includePrompts);
    }
    if (message.excludeUserStoryPrompts !== false) {
      writer.uint32(24).bool(message.excludeUserStoryPrompts);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinearIntegrationProperties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinearIntegrationProperties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.noLinkBack = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includePrompts = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.excludeUserStoryPrompts = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinearIntegrationProperties {
    return {
      noLinkBack: isSet(object.noLinkBack)
        ? globalThis.Boolean(object.noLinkBack)
        : isSet(object.no_link_back)
        ? globalThis.Boolean(object.no_link_back)
        : false,
      includePrompts: isSet(object.includePrompts)
        ? globalThis.Boolean(object.includePrompts)
        : isSet(object.include_prompts)
        ? globalThis.Boolean(object.include_prompts)
        : false,
      excludeUserStoryPrompts: isSet(object.excludeUserStoryPrompts)
        ? globalThis.Boolean(object.excludeUserStoryPrompts)
        : isSet(object.exclude_user_story_prompts)
        ? globalThis.Boolean(object.exclude_user_story_prompts)
        : false,
    };
  },

  toJSON(message: LinearIntegrationProperties): unknown {
    const obj: any = {};
    if (message.noLinkBack !== false) {
      obj.noLinkBack = message.noLinkBack;
    }
    if (message.includePrompts !== false) {
      obj.includePrompts = message.includePrompts;
    }
    if (message.excludeUserStoryPrompts !== false) {
      obj.excludeUserStoryPrompts = message.excludeUserStoryPrompts;
    }
    return obj;
  },

  create(base?: DeepPartial<LinearIntegrationProperties>): LinearIntegrationProperties {
    return LinearIntegrationProperties.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LinearIntegrationProperties>): LinearIntegrationProperties {
    const message = createBaseLinearIntegrationProperties();
    message.noLinkBack = object.noLinkBack ?? false;
    message.includePrompts = object.includePrompts ?? false;
    message.excludeUserStoryPrompts = object.excludeUserStoryPrompts ?? false;
    return message;
  },
};

function createBaseGitHubIntegrationProperties(): GitHubIntegrationProperties {
  return {};
}

export const GitHubIntegrationProperties: MessageFns<GitHubIntegrationProperties> = {
  encode(_: GitHubIntegrationProperties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GitHubIntegrationProperties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGitHubIntegrationProperties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GitHubIntegrationProperties {
    return {};
  },

  toJSON(_: GitHubIntegrationProperties): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<GitHubIntegrationProperties>): GitHubIntegrationProperties {
    return GitHubIntegrationProperties.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<GitHubIntegrationProperties>): GitHubIntegrationProperties {
    const message = createBaseGitHubIntegrationProperties();
    return message;
  },
};

function createBaseJiraIntegrationProperties(): JiraIntegrationProperties {
  return {
    noLinkBack: false,
    includePrompts: false,
    extraFields: [],
    allowedProjectKeys: [],
    excludeUserStoryPrompts: false,
  };
}

export const JiraIntegrationProperties: MessageFns<JiraIntegrationProperties> = {
  encode(message: JiraIntegrationProperties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.noLinkBack !== false) {
      writer.uint32(8).bool(message.noLinkBack);
    }
    if (message.includePrompts !== false) {
      writer.uint32(16).bool(message.includePrompts);
    }
    for (const v of message.extraFields) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.allowedProjectKeys) {
      writer.uint32(34).string(v!);
    }
    if (message.excludeUserStoryPrompts !== false) {
      writer.uint32(40).bool(message.excludeUserStoryPrompts);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraIntegrationProperties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraIntegrationProperties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.noLinkBack = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includePrompts = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.extraFields.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.allowedProjectKeys.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.excludeUserStoryPrompts = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraIntegrationProperties {
    return {
      noLinkBack: isSet(object.noLinkBack)
        ? globalThis.Boolean(object.noLinkBack)
        : isSet(object.no_link_back)
        ? globalThis.Boolean(object.no_link_back)
        : false,
      includePrompts: isSet(object.includePrompts)
        ? globalThis.Boolean(object.includePrompts)
        : isSet(object.include_prompts)
        ? globalThis.Boolean(object.include_prompts)
        : false,
      extraFields: globalThis.Array.isArray(object?.extraFields)
        ? object.extraFields.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.extra_fields)
        ? object.extra_fields.map((e: any) => globalThis.String(e))
        : [],
      allowedProjectKeys: globalThis.Array.isArray(object?.allowedProjectKeys)
        ? object.allowedProjectKeys.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.allowed_project_keys)
        ? object.allowed_project_keys.map((e: any) => globalThis.String(e))
        : [],
      excludeUserStoryPrompts: isSet(object.excludeUserStoryPrompts)
        ? globalThis.Boolean(object.excludeUserStoryPrompts)
        : isSet(object.exclude_user_story_prompts)
        ? globalThis.Boolean(object.exclude_user_story_prompts)
        : false,
    };
  },

  toJSON(message: JiraIntegrationProperties): unknown {
    const obj: any = {};
    if (message.noLinkBack !== false) {
      obj.noLinkBack = message.noLinkBack;
    }
    if (message.includePrompts !== false) {
      obj.includePrompts = message.includePrompts;
    }
    if (message.extraFields?.length) {
      obj.extraFields = message.extraFields;
    }
    if (message.allowedProjectKeys?.length) {
      obj.allowedProjectKeys = message.allowedProjectKeys;
    }
    if (message.excludeUserStoryPrompts !== false) {
      obj.excludeUserStoryPrompts = message.excludeUserStoryPrompts;
    }
    return obj;
  },

  create(base?: DeepPartial<JiraIntegrationProperties>): JiraIntegrationProperties {
    return JiraIntegrationProperties.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraIntegrationProperties>): JiraIntegrationProperties {
    const message = createBaseJiraIntegrationProperties();
    message.noLinkBack = object.noLinkBack ?? false;
    message.includePrompts = object.includePrompts ?? false;
    message.extraFields = object.extraFields?.map((e) => e) || [];
    message.allowedProjectKeys = object.allowedProjectKeys?.map((e) => e) || [];
    message.excludeUserStoryPrompts = object.excludeUserStoryPrompts ?? false;
    return message;
  },
};

function createBaseSlackWorkspace(): SlackWorkspace {
  return { id: "", name: "", domain: "", url: "" };
}

export const SlackWorkspace: MessageFns<SlackWorkspace> = {
  encode(message: SlackWorkspace, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.domain !== "") {
      writer.uint32(26).string(message.domain);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackWorkspace {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlackWorkspace();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.domain = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlackWorkspace {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      domain: isSet(object.domain) ? globalThis.String(object.domain) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: SlackWorkspace): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.domain !== "") {
      obj.domain = message.domain;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<SlackWorkspace>): SlackWorkspace {
    return SlackWorkspace.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SlackWorkspace>): SlackWorkspace {
    const message = createBaseSlackWorkspace();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.domain = object.domain ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseSlackIntegrationInfo(): SlackIntegrationInfo {
  return { workspace: undefined };
}

export const SlackIntegrationInfo: MessageFns<SlackIntegrationInfo> = {
  encode(message: SlackIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workspace !== undefined) {
      SlackWorkspace.encode(message.workspace, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlackIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workspace = SlackWorkspace.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlackIntegrationInfo {
    return { workspace: isSet(object.workspace) ? SlackWorkspace.fromJSON(object.workspace) : undefined };
  },

  toJSON(message: SlackIntegrationInfo): unknown {
    const obj: any = {};
    if (message.workspace !== undefined) {
      obj.workspace = SlackWorkspace.toJSON(message.workspace);
    }
    return obj;
  },

  create(base?: DeepPartial<SlackIntegrationInfo>): SlackIntegrationInfo {
    return SlackIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SlackIntegrationInfo>): SlackIntegrationInfo {
    const message = createBaseSlackIntegrationInfo();
    message.workspace = (object.workspace !== undefined && object.workspace !== null)
      ? SlackWorkspace.fromPartial(object.workspace)
      : undefined;
    return message;
  },
};

function createBaseSlackOnboardingMessage(): SlackOnboardingMessage {
  return {
    companyId: 0,
    slackWorkspaceId: "",
    slackUserId: "",
    devplanUserId: "",
    dmChannelId: undefined,
    welcomeSentAt: undefined,
    companyProfileSentAt: undefined,
    competitiveAnalysisSentAt: undefined,
    productGraphSentAt: undefined,
    retryCount: 0,
    nextAttemptAt: undefined,
    claimLeaseUntil: undefined,
    lastError: undefined,
    pausedAt: undefined,
    createdAt: undefined,
    updatedAt: undefined,
  };
}

export const SlackOnboardingMessage: MessageFns<SlackOnboardingMessage> = {
  encode(message: SlackOnboardingMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.slackWorkspaceId !== "") {
      writer.uint32(18).string(message.slackWorkspaceId);
    }
    if (message.slackUserId !== "") {
      writer.uint32(26).string(message.slackUserId);
    }
    if (message.devplanUserId !== "") {
      writer.uint32(34).string(message.devplanUserId);
    }
    if (message.dmChannelId !== undefined) {
      writer.uint32(42).string(message.dmChannelId);
    }
    if (message.welcomeSentAt !== undefined) {
      Timestamp.encode(toTimestamp(message.welcomeSentAt), writer.uint32(50).fork()).join();
    }
    if (message.companyProfileSentAt !== undefined) {
      Timestamp.encode(toTimestamp(message.companyProfileSentAt), writer.uint32(58).fork()).join();
    }
    if (message.competitiveAnalysisSentAt !== undefined) {
      Timestamp.encode(toTimestamp(message.competitiveAnalysisSentAt), writer.uint32(66).fork()).join();
    }
    if (message.productGraphSentAt !== undefined) {
      Timestamp.encode(toTimestamp(message.productGraphSentAt), writer.uint32(74).fork()).join();
    }
    if (message.retryCount !== 0) {
      writer.uint32(80).int32(message.retryCount);
    }
    if (message.nextAttemptAt !== undefined) {
      Timestamp.encode(toTimestamp(message.nextAttemptAt), writer.uint32(90).fork()).join();
    }
    if (message.claimLeaseUntil !== undefined) {
      Timestamp.encode(toTimestamp(message.claimLeaseUntil), writer.uint32(98).fork()).join();
    }
    if (message.lastError !== undefined) {
      writer.uint32(106).string(message.lastError);
    }
    if (message.pausedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.pausedAt), writer.uint32(114).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(122).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(130).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackOnboardingMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlackOnboardingMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.slackWorkspaceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.slackUserId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.devplanUserId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.dmChannelId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.welcomeSentAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.companyProfileSentAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.competitiveAnalysisSentAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.productGraphSentAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.retryCount = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.nextAttemptAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.claimLeaseUntil = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.lastError = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.pausedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlackOnboardingMessage {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      slackWorkspaceId: isSet(object.slackWorkspaceId)
        ? globalThis.String(object.slackWorkspaceId)
        : isSet(object.slack_workspace_id)
        ? globalThis.String(object.slack_workspace_id)
        : "",
      slackUserId: isSet(object.slackUserId)
        ? globalThis.String(object.slackUserId)
        : isSet(object.slack_user_id)
        ? globalThis.String(object.slack_user_id)
        : "",
      devplanUserId: isSet(object.devplanUserId)
        ? globalThis.String(object.devplanUserId)
        : isSet(object.devplan_user_id)
        ? globalThis.String(object.devplan_user_id)
        : "",
      dmChannelId: isSet(object.dmChannelId)
        ? globalThis.String(object.dmChannelId)
        : isSet(object.dm_channel_id)
        ? globalThis.String(object.dm_channel_id)
        : undefined,
      welcomeSentAt: isSet(object.welcomeSentAt)
        ? fromJsonTimestamp(object.welcomeSentAt)
        : isSet(object.welcome_sent_at)
        ? fromJsonTimestamp(object.welcome_sent_at)
        : undefined,
      companyProfileSentAt: isSet(object.companyProfileSentAt)
        ? fromJsonTimestamp(object.companyProfileSentAt)
        : isSet(object.company_profile_sent_at)
        ? fromJsonTimestamp(object.company_profile_sent_at)
        : undefined,
      competitiveAnalysisSentAt: isSet(object.competitiveAnalysisSentAt)
        ? fromJsonTimestamp(object.competitiveAnalysisSentAt)
        : isSet(object.competitive_analysis_sent_at)
        ? fromJsonTimestamp(object.competitive_analysis_sent_at)
        : undefined,
      productGraphSentAt: isSet(object.productGraphSentAt)
        ? fromJsonTimestamp(object.productGraphSentAt)
        : isSet(object.product_graph_sent_at)
        ? fromJsonTimestamp(object.product_graph_sent_at)
        : undefined,
      retryCount: isSet(object.retryCount)
        ? globalThis.Number(object.retryCount)
        : isSet(object.retry_count)
        ? globalThis.Number(object.retry_count)
        : 0,
      nextAttemptAt: isSet(object.nextAttemptAt)
        ? fromJsonTimestamp(object.nextAttemptAt)
        : isSet(object.next_attempt_at)
        ? fromJsonTimestamp(object.next_attempt_at)
        : undefined,
      claimLeaseUntil: isSet(object.claimLeaseUntil)
        ? fromJsonTimestamp(object.claimLeaseUntil)
        : isSet(object.claim_lease_until)
        ? fromJsonTimestamp(object.claim_lease_until)
        : undefined,
      lastError: isSet(object.lastError)
        ? globalThis.String(object.lastError)
        : isSet(object.last_error)
        ? globalThis.String(object.last_error)
        : undefined,
      pausedAt: isSet(object.pausedAt)
        ? fromJsonTimestamp(object.pausedAt)
        : isSet(object.paused_at)
        ? fromJsonTimestamp(object.paused_at)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: SlackOnboardingMessage): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.slackWorkspaceId !== "") {
      obj.slackWorkspaceId = message.slackWorkspaceId;
    }
    if (message.slackUserId !== "") {
      obj.slackUserId = message.slackUserId;
    }
    if (message.devplanUserId !== "") {
      obj.devplanUserId = message.devplanUserId;
    }
    if (message.dmChannelId !== undefined) {
      obj.dmChannelId = message.dmChannelId;
    }
    if (message.welcomeSentAt !== undefined) {
      obj.welcomeSentAt = message.welcomeSentAt.toISOString();
    }
    if (message.companyProfileSentAt !== undefined) {
      obj.companyProfileSentAt = message.companyProfileSentAt.toISOString();
    }
    if (message.competitiveAnalysisSentAt !== undefined) {
      obj.competitiveAnalysisSentAt = message.competitiveAnalysisSentAt.toISOString();
    }
    if (message.productGraphSentAt !== undefined) {
      obj.productGraphSentAt = message.productGraphSentAt.toISOString();
    }
    if (message.retryCount !== 0) {
      obj.retryCount = Math.round(message.retryCount);
    }
    if (message.nextAttemptAt !== undefined) {
      obj.nextAttemptAt = message.nextAttemptAt.toISOString();
    }
    if (message.claimLeaseUntil !== undefined) {
      obj.claimLeaseUntil = message.claimLeaseUntil.toISOString();
    }
    if (message.lastError !== undefined) {
      obj.lastError = message.lastError;
    }
    if (message.pausedAt !== undefined) {
      obj.pausedAt = message.pausedAt.toISOString();
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<SlackOnboardingMessage>): SlackOnboardingMessage {
    return SlackOnboardingMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SlackOnboardingMessage>): SlackOnboardingMessage {
    const message = createBaseSlackOnboardingMessage();
    message.companyId = object.companyId ?? 0;
    message.slackWorkspaceId = object.slackWorkspaceId ?? "";
    message.slackUserId = object.slackUserId ?? "";
    message.devplanUserId = object.devplanUserId ?? "";
    message.dmChannelId = object.dmChannelId ?? undefined;
    message.welcomeSentAt = object.welcomeSentAt ?? undefined;
    message.companyProfileSentAt = object.companyProfileSentAt ?? undefined;
    message.competitiveAnalysisSentAt = object.competitiveAnalysisSentAt ?? undefined;
    message.productGraphSentAt = object.productGraphSentAt ?? undefined;
    message.retryCount = object.retryCount ?? 0;
    message.nextAttemptAt = object.nextAttemptAt ?? undefined;
    message.claimLeaseUntil = object.claimLeaseUntil ?? undefined;
    message.lastError = object.lastError ?? undefined;
    message.pausedAt = object.pausedAt ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseTeamsTenant(): TeamsTenant {
  return { id: "", name: "" };
}

export const TeamsTenant: MessageFns<TeamsTenant> = {
  encode(message: TeamsTenant, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeamsTenant {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamsTenant();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamsTenant {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: TeamsTenant): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create(base?: DeepPartial<TeamsTenant>): TeamsTenant {
    return TeamsTenant.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TeamsTenant>): TeamsTenant {
    const message = createBaseTeamsTenant();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseTeamsTeam(): TeamsTeam {
  return { id: "", displayName: "" };
}

export const TeamsTeam: MessageFns<TeamsTeam> = {
  encode(message: TeamsTeam, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeamsTeam {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamsTeam();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamsTeam {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      displayName: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
        ? globalThis.String(object.display_name)
        : "",
    };
  },

  toJSON(message: TeamsTeam): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    return obj;
  },

  create(base?: DeepPartial<TeamsTeam>): TeamsTeam {
    return TeamsTeam.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TeamsTeam>): TeamsTeam {
    const message = createBaseTeamsTeam();
    message.id = object.id ?? "";
    message.displayName = object.displayName ?? "";
    return message;
  },
};

function createBaseTeamsChannel(): TeamsChannel {
  return { id: "", displayName: "", teamId: "" };
}

export const TeamsChannel: MessageFns<TeamsChannel> = {
  encode(message: TeamsChannel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    if (message.teamId !== "") {
      writer.uint32(26).string(message.teamId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeamsChannel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamsChannel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.teamId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamsChannel {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      displayName: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
        ? globalThis.String(object.display_name)
        : "",
      teamId: isSet(object.teamId)
        ? globalThis.String(object.teamId)
        : isSet(object.team_id)
        ? globalThis.String(object.team_id)
        : "",
    };
  },

  toJSON(message: TeamsChannel): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.teamId !== "") {
      obj.teamId = message.teamId;
    }
    return obj;
  },

  create(base?: DeepPartial<TeamsChannel>): TeamsChannel {
    return TeamsChannel.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TeamsChannel>): TeamsChannel {
    const message = createBaseTeamsChannel();
    message.id = object.id ?? "";
    message.displayName = object.displayName ?? "";
    message.teamId = object.teamId ?? "";
    return message;
  },
};

function createBaseTeamsIntegrationInfo(): TeamsIntegrationInfo {
  return { tenant: undefined, teams: [], serviceUrl: "", installedTeamIds: [] };
}

export const TeamsIntegrationInfo: MessageFns<TeamsIntegrationInfo> = {
  encode(message: TeamsIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenant !== undefined) {
      TeamsTenant.encode(message.tenant, writer.uint32(10).fork()).join();
    }
    for (const v of message.teams) {
      TeamsTeam.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.serviceUrl !== "") {
      writer.uint32(26).string(message.serviceUrl);
    }
    for (const v of message.installedTeamIds) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeamsIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamsIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenant = TeamsTenant.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.teams.push(TeamsTeam.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serviceUrl = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.installedTeamIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamsIntegrationInfo {
    return {
      tenant: isSet(object.tenant) ? TeamsTenant.fromJSON(object.tenant) : undefined,
      teams: globalThis.Array.isArray(object?.teams) ? object.teams.map((e: any) => TeamsTeam.fromJSON(e)) : [],
      serviceUrl: isSet(object.serviceUrl)
        ? globalThis.String(object.serviceUrl)
        : isSet(object.service_url)
        ? globalThis.String(object.service_url)
        : "",
      installedTeamIds: globalThis.Array.isArray(object?.installedTeamIds)
        ? object.installedTeamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.installed_team_ids)
        ? object.installed_team_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: TeamsIntegrationInfo): unknown {
    const obj: any = {};
    if (message.tenant !== undefined) {
      obj.tenant = TeamsTenant.toJSON(message.tenant);
    }
    if (message.teams?.length) {
      obj.teams = message.teams.map((e) => TeamsTeam.toJSON(e));
    }
    if (message.serviceUrl !== "") {
      obj.serviceUrl = message.serviceUrl;
    }
    if (message.installedTeamIds?.length) {
      obj.installedTeamIds = message.installedTeamIds;
    }
    return obj;
  },

  create(base?: DeepPartial<TeamsIntegrationInfo>): TeamsIntegrationInfo {
    return TeamsIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TeamsIntegrationInfo>): TeamsIntegrationInfo {
    const message = createBaseTeamsIntegrationInfo();
    message.tenant = (object.tenant !== undefined && object.tenant !== null)
      ? TeamsTenant.fromPartial(object.tenant)
      : undefined;
    message.teams = object.teams?.map((e) => TeamsTeam.fromPartial(e)) || [];
    message.serviceUrl = object.serviceUrl ?? "";
    message.installedTeamIds = object.installedTeamIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseNotionRoot(): NotionRoot {
  return { id: "", title: "", objectType: 0, url: "" };
}

export const NotionRoot: MessageFns<NotionRoot> = {
  encode(message: NotionRoot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.objectType !== 0) {
      writer.uint32(24).int32(message.objectType);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotionRoot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotionRoot();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.objectType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotionRoot {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      objectType: isSet(object.objectType)
        ? notionRootObjectTypeFromJSON(object.objectType)
        : isSet(object.object_type)
        ? notionRootObjectTypeFromJSON(object.object_type)
        : 0,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: NotionRoot): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.objectType !== 0) {
      obj.objectType = notionRootObjectTypeToJSON(message.objectType);
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<NotionRoot>): NotionRoot {
    return NotionRoot.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NotionRoot>): NotionRoot {
    const message = createBaseNotionRoot();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.objectType = object.objectType ?? 0;
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseNotionIntegrationInfo(): NotionIntegrationInfo {
  return { roots: [] };
}

export const NotionIntegrationInfo: MessageFns<NotionIntegrationInfo> = {
  encode(message: NotionIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.roots) {
      NotionRoot.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotionIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotionIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roots.push(NotionRoot.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotionIntegrationInfo {
    return {
      roots: globalThis.Array.isArray(object?.roots) ? object.roots.map((e: any) => NotionRoot.fromJSON(e)) : [],
    };
  },

  toJSON(message: NotionIntegrationInfo): unknown {
    const obj: any = {};
    if (message.roots?.length) {
      obj.roots = message.roots.map((e) => NotionRoot.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<NotionIntegrationInfo>): NotionIntegrationInfo {
    return NotionIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NotionIntegrationInfo>): NotionIntegrationInfo {
    const message = createBaseNotionIntegrationInfo();
    message.roots = object.roots?.map((e) => NotionRoot.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAttachNotionItem(): AttachNotionItem {
  return { notionRootId: "", notionPageId: "", objectType: 0, title: "", url: "", parentTitle: "", lastEditedTime: "" };
}

export const AttachNotionItem: MessageFns<AttachNotionItem> = {
  encode(message: AttachNotionItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.notionRootId !== "") {
      writer.uint32(10).string(message.notionRootId);
    }
    if (message.notionPageId !== "") {
      writer.uint32(18).string(message.notionPageId);
    }
    if (message.objectType !== 0) {
      writer.uint32(24).int32(message.objectType);
    }
    if (message.title !== "") {
      writer.uint32(34).string(message.title);
    }
    if (message.url !== "") {
      writer.uint32(42).string(message.url);
    }
    if (message.parentTitle !== "") {
      writer.uint32(50).string(message.parentTitle);
    }
    if (message.lastEditedTime !== "") {
      writer.uint32(58).string(message.lastEditedTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachNotionItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachNotionItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.notionRootId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.notionPageId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.objectType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentTitle = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.lastEditedTime = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachNotionItem {
    return {
      notionRootId: isSet(object.notionRootId)
        ? globalThis.String(object.notionRootId)
        : isSet(object.notion_root_id)
        ? globalThis.String(object.notion_root_id)
        : "",
      notionPageId: isSet(object.notionPageId)
        ? globalThis.String(object.notionPageId)
        : isSet(object.notion_page_id)
        ? globalThis.String(object.notion_page_id)
        : "",
      objectType: isSet(object.objectType)
        ? notionRootObjectTypeFromJSON(object.objectType)
        : isSet(object.object_type)
        ? notionRootObjectTypeFromJSON(object.object_type)
        : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      parentTitle: isSet(object.parentTitle)
        ? globalThis.String(object.parentTitle)
        : isSet(object.parent_title)
        ? globalThis.String(object.parent_title)
        : "",
      lastEditedTime: isSet(object.lastEditedTime)
        ? globalThis.String(object.lastEditedTime)
        : isSet(object.last_edited_time)
        ? globalThis.String(object.last_edited_time)
        : "",
    };
  },

  toJSON(message: AttachNotionItem): unknown {
    const obj: any = {};
    if (message.notionRootId !== "") {
      obj.notionRootId = message.notionRootId;
    }
    if (message.notionPageId !== "") {
      obj.notionPageId = message.notionPageId;
    }
    if (message.objectType !== 0) {
      obj.objectType = notionRootObjectTypeToJSON(message.objectType);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.parentTitle !== "") {
      obj.parentTitle = message.parentTitle;
    }
    if (message.lastEditedTime !== "") {
      obj.lastEditedTime = message.lastEditedTime;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachNotionItem>): AttachNotionItem {
    return AttachNotionItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachNotionItem>): AttachNotionItem {
    const message = createBaseAttachNotionItem();
    message.notionRootId = object.notionRootId ?? "";
    message.notionPageId = object.notionPageId ?? "";
    message.objectType = object.objectType ?? 0;
    message.title = object.title ?? "";
    message.url = object.url ?? "";
    message.parentTitle = object.parentTitle ?? "";
    message.lastEditedTime = object.lastEditedTime ?? "";
    return message;
  },
};

function createBaseNotionPageSummary(): NotionPageSummary {
  return { id: "", title: "", url: "", lastEditedTime: "" };
}

export const NotionPageSummary: MessageFns<NotionPageSummary> = {
  encode(message: NotionPageSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.url !== "") {
      writer.uint32(26).string(message.url);
    }
    if (message.lastEditedTime !== "") {
      writer.uint32(34).string(message.lastEditedTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotionPageSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotionPageSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lastEditedTime = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotionPageSummary {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      lastEditedTime: isSet(object.lastEditedTime)
        ? globalThis.String(object.lastEditedTime)
        : isSet(object.last_edited_time)
        ? globalThis.String(object.last_edited_time)
        : "",
    };
  },

  toJSON(message: NotionPageSummary): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.lastEditedTime !== "") {
      obj.lastEditedTime = message.lastEditedTime;
    }
    return obj;
  },

  create(base?: DeepPartial<NotionPageSummary>): NotionPageSummary {
    return NotionPageSummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NotionPageSummary>): NotionPageSummary {
    const message = createBaseNotionPageSummary();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.url = object.url ?? "";
    message.lastEditedTime = object.lastEditedTime ?? "";
    return message;
  },
};

function createBaseConfluenceRoot(): ConfluenceRoot {
  return { id: "", title: "", objectType: 0, url: "", spaceKey: "" };
}

export const ConfluenceRoot: MessageFns<ConfluenceRoot> = {
  encode(message: ConfluenceRoot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.objectType !== 0) {
      writer.uint32(24).int32(message.objectType);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    if (message.spaceKey !== "") {
      writer.uint32(42).string(message.spaceKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfluenceRoot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfluenceRoot();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.objectType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.spaceKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfluenceRoot {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      objectType: isSet(object.objectType)
        ? confluenceRootObjectTypeFromJSON(object.objectType)
        : isSet(object.object_type)
        ? confluenceRootObjectTypeFromJSON(object.object_type)
        : 0,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      spaceKey: isSet(object.spaceKey)
        ? globalThis.String(object.spaceKey)
        : isSet(object.space_key)
        ? globalThis.String(object.space_key)
        : "",
    };
  },

  toJSON(message: ConfluenceRoot): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.objectType !== 0) {
      obj.objectType = confluenceRootObjectTypeToJSON(message.objectType);
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.spaceKey !== "") {
      obj.spaceKey = message.spaceKey;
    }
    return obj;
  },

  create(base?: DeepPartial<ConfluenceRoot>): ConfluenceRoot {
    return ConfluenceRoot.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ConfluenceRoot>): ConfluenceRoot {
    const message = createBaseConfluenceRoot();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.objectType = object.objectType ?? 0;
    message.url = object.url ?? "";
    message.spaceKey = object.spaceKey ?? "";
    return message;
  },
};

function createBaseConfluenceIntegrationInfo(): ConfluenceIntegrationInfo {
  return { cloudId: "", siteUrl: "", roots: [], rootsSyncedAt: "", disconnectedAt: "" };
}

export const ConfluenceIntegrationInfo: MessageFns<ConfluenceIntegrationInfo> = {
  encode(message: ConfluenceIntegrationInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cloudId !== "") {
      writer.uint32(10).string(message.cloudId);
    }
    if (message.siteUrl !== "") {
      writer.uint32(18).string(message.siteUrl);
    }
    for (const v of message.roots) {
      ConfluenceRoot.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.rootsSyncedAt !== "") {
      writer.uint32(34).string(message.rootsSyncedAt);
    }
    if (message.disconnectedAt !== "") {
      writer.uint32(42).string(message.disconnectedAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfluenceIntegrationInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfluenceIntegrationInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cloudId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.siteUrl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.roots.push(ConfluenceRoot.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.rootsSyncedAt = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.disconnectedAt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfluenceIntegrationInfo {
    return {
      cloudId: isSet(object.cloudId)
        ? globalThis.String(object.cloudId)
        : isSet(object.cloud_id)
        ? globalThis.String(object.cloud_id)
        : "",
      siteUrl: isSet(object.siteUrl)
        ? globalThis.String(object.siteUrl)
        : isSet(object.site_url)
        ? globalThis.String(object.site_url)
        : "",
      roots: globalThis.Array.isArray(object?.roots) ? object.roots.map((e: any) => ConfluenceRoot.fromJSON(e)) : [],
      rootsSyncedAt: isSet(object.rootsSyncedAt)
        ? globalThis.String(object.rootsSyncedAt)
        : isSet(object.roots_synced_at)
        ? globalThis.String(object.roots_synced_at)
        : "",
      disconnectedAt: isSet(object.disconnectedAt)
        ? globalThis.String(object.disconnectedAt)
        : isSet(object.disconnected_at)
        ? globalThis.String(object.disconnected_at)
        : "",
    };
  },

  toJSON(message: ConfluenceIntegrationInfo): unknown {
    const obj: any = {};
    if (message.cloudId !== "") {
      obj.cloudId = message.cloudId;
    }
    if (message.siteUrl !== "") {
      obj.siteUrl = message.siteUrl;
    }
    if (message.roots?.length) {
      obj.roots = message.roots.map((e) => ConfluenceRoot.toJSON(e));
    }
    if (message.rootsSyncedAt !== "") {
      obj.rootsSyncedAt = message.rootsSyncedAt;
    }
    if (message.disconnectedAt !== "") {
      obj.disconnectedAt = message.disconnectedAt;
    }
    return obj;
  },

  create(base?: DeepPartial<ConfluenceIntegrationInfo>): ConfluenceIntegrationInfo {
    return ConfluenceIntegrationInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ConfluenceIntegrationInfo>): ConfluenceIntegrationInfo {
    const message = createBaseConfluenceIntegrationInfo();
    message.cloudId = object.cloudId ?? "";
    message.siteUrl = object.siteUrl ?? "";
    message.roots = object.roots?.map((e) => ConfluenceRoot.fromPartial(e)) || [];
    message.rootsSyncedAt = object.rootsSyncedAt ?? "";
    message.disconnectedAt = object.disconnectedAt ?? "";
    return message;
  },
};

function createBaseAttachConfluenceItem(): AttachConfluenceItem {
  return {
    cloudId: "",
    spaceId: "",
    spaceKey: "",
    confluencePageId: "",
    objectType: 0,
    title: "",
    url: "",
    parentTitle: "",
    lastEditedTime: "",
  };
}

export const AttachConfluenceItem: MessageFns<AttachConfluenceItem> = {
  encode(message: AttachConfluenceItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cloudId !== "") {
      writer.uint32(10).string(message.cloudId);
    }
    if (message.spaceId !== "") {
      writer.uint32(18).string(message.spaceId);
    }
    if (message.spaceKey !== "") {
      writer.uint32(26).string(message.spaceKey);
    }
    if (message.confluencePageId !== "") {
      writer.uint32(34).string(message.confluencePageId);
    }
    if (message.objectType !== 0) {
      writer.uint32(40).int32(message.objectType);
    }
    if (message.title !== "") {
      writer.uint32(50).string(message.title);
    }
    if (message.url !== "") {
      writer.uint32(58).string(message.url);
    }
    if (message.parentTitle !== "") {
      writer.uint32(66).string(message.parentTitle);
    }
    if (message.lastEditedTime !== "") {
      writer.uint32(74).string(message.lastEditedTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachConfluenceItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachConfluenceItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cloudId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.spaceKey = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.confluencePageId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.objectType = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.parentTitle = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.lastEditedTime = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachConfluenceItem {
    return {
      cloudId: isSet(object.cloudId)
        ? globalThis.String(object.cloudId)
        : isSet(object.cloud_id)
        ? globalThis.String(object.cloud_id)
        : "",
      spaceId: isSet(object.spaceId)
        ? globalThis.String(object.spaceId)
        : isSet(object.space_id)
        ? globalThis.String(object.space_id)
        : "",
      spaceKey: isSet(object.spaceKey)
        ? globalThis.String(object.spaceKey)
        : isSet(object.space_key)
        ? globalThis.String(object.space_key)
        : "",
      confluencePageId: isSet(object.confluencePageId)
        ? globalThis.String(object.confluencePageId)
        : isSet(object.confluence_page_id)
        ? globalThis.String(object.confluence_page_id)
        : "",
      objectType: isSet(object.objectType)
        ? confluenceRootObjectTypeFromJSON(object.objectType)
        : isSet(object.object_type)
        ? confluenceRootObjectTypeFromJSON(object.object_type)
        : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      parentTitle: isSet(object.parentTitle)
        ? globalThis.String(object.parentTitle)
        : isSet(object.parent_title)
        ? globalThis.String(object.parent_title)
        : "",
      lastEditedTime: isSet(object.lastEditedTime)
        ? globalThis.String(object.lastEditedTime)
        : isSet(object.last_edited_time)
        ? globalThis.String(object.last_edited_time)
        : "",
    };
  },

  toJSON(message: AttachConfluenceItem): unknown {
    const obj: any = {};
    if (message.cloudId !== "") {
      obj.cloudId = message.cloudId;
    }
    if (message.spaceId !== "") {
      obj.spaceId = message.spaceId;
    }
    if (message.spaceKey !== "") {
      obj.spaceKey = message.spaceKey;
    }
    if (message.confluencePageId !== "") {
      obj.confluencePageId = message.confluencePageId;
    }
    if (message.objectType !== 0) {
      obj.objectType = confluenceRootObjectTypeToJSON(message.objectType);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.parentTitle !== "") {
      obj.parentTitle = message.parentTitle;
    }
    if (message.lastEditedTime !== "") {
      obj.lastEditedTime = message.lastEditedTime;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachConfluenceItem>): AttachConfluenceItem {
    return AttachConfluenceItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachConfluenceItem>): AttachConfluenceItem {
    const message = createBaseAttachConfluenceItem();
    message.cloudId = object.cloudId ?? "";
    message.spaceId = object.spaceId ?? "";
    message.spaceKey = object.spaceKey ?? "";
    message.confluencePageId = object.confluencePageId ?? "";
    message.objectType = object.objectType ?? 0;
    message.title = object.title ?? "";
    message.url = object.url ?? "";
    message.parentTitle = object.parentTitle ?? "";
    message.lastEditedTime = object.lastEditedTime ?? "";
    return message;
  },
};

function createBaseConfluencePageSummary(): ConfluencePageSummary {
  return { id: "", title: "", url: "", lastEditedTime: "" };
}

export const ConfluencePageSummary: MessageFns<ConfluencePageSummary> = {
  encode(message: ConfluencePageSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.url !== "") {
      writer.uint32(26).string(message.url);
    }
    if (message.lastEditedTime !== "") {
      writer.uint32(34).string(message.lastEditedTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfluencePageSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfluencePageSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lastEditedTime = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfluencePageSummary {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      lastEditedTime: isSet(object.lastEditedTime)
        ? globalThis.String(object.lastEditedTime)
        : isSet(object.last_edited_time)
        ? globalThis.String(object.last_edited_time)
        : "",
    };
  },

  toJSON(message: ConfluencePageSummary): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.lastEditedTime !== "") {
      obj.lastEditedTime = message.lastEditedTime;
    }
    return obj;
  },

  create(base?: DeepPartial<ConfluencePageSummary>): ConfluencePageSummary {
    return ConfluencePageSummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ConfluencePageSummary>): ConfluencePageSummary {
    const message = createBaseConfluencePageSummary();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.url = object.url ?? "";
    message.lastEditedTime = object.lastEditedTime ?? "";
    return message;
  },
};

function createBaseGoogleDriveFolder(): GoogleDriveFolder {
  return { id: "", name: "", isDrive: false };
}

export const GoogleDriveFolder: MessageFns<GoogleDriveFolder> = {
  encode(message: GoogleDriveFolder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.isDrive !== false) {
      writer.uint32(24).bool(message.isDrive);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleDriveFolder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleDriveFolder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isDrive = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleDriveFolder {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      isDrive: isSet(object.isDrive)
        ? globalThis.Boolean(object.isDrive)
        : isSet(object.is_drive)
        ? globalThis.Boolean(object.is_drive)
        : false,
    };
  },

  toJSON(message: GoogleDriveFolder): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.isDrive !== false) {
      obj.isDrive = message.isDrive;
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleDriveFolder>): GoogleDriveFolder {
    return GoogleDriveFolder.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleDriveFolder>): GoogleDriveFolder {
    const message = createBaseGoogleDriveFolder();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.isDrive = object.isDrive ?? false;
    return message;
  },
};

function createBaseGoogleDriveFile(): GoogleDriveFile {
  return { id: "", name: "", mimeType: "", url: "" };
}

export const GoogleDriveFile: MessageFns<GoogleDriveFile> = {
  encode(message: GoogleDriveFile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.mimeType !== "") {
      writer.uint32(26).string(message.mimeType);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleDriveFile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleDriveFile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleDriveFile {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      mimeType: isSet(object.mimeType)
        ? globalThis.String(object.mimeType)
        : isSet(object.mime_type)
        ? globalThis.String(object.mime_type)
        : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: GoogleDriveFile): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleDriveFile>): GoogleDriveFile {
    return GoogleDriveFile.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleDriveFile>): GoogleDriveFile {
    const message = createBaseGoogleDriveFile();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.mimeType = object.mimeType ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseRepoMetadata(): RepoMetadata {
  return { id: "", companyId: 0, analysis: undefined, observerId: undefined, provider: 0 };
}

export const RepoMetadata: MessageFns<RepoMetadata> = {
  encode(message: RepoMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.analysis !== undefined) {
      RepoAnalysisSettings.encode(message.analysis, writer.uint32(26).fork()).join();
    }
    if (message.observerId !== undefined) {
      writer.uint32(34).string(message.observerId);
    }
    if (message.provider !== 0) {
      writer.uint32(40).int32(message.provider);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.analysis = RepoAnalysisSettings.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.observerId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoMetadata {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      analysis: isSet(object.analysis) ? RepoAnalysisSettings.fromJSON(object.analysis) : undefined,
      observerId: isSet(object.observerId)
        ? globalThis.String(object.observerId)
        : isSet(object.observer_id)
        ? globalThis.String(object.observer_id)
        : undefined,
      provider: isSet(object.provider) ? gitProviderFromJSON(object.provider) : 0,
    };
  },

  toJSON(message: RepoMetadata): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.analysis !== undefined) {
      obj.analysis = RepoAnalysisSettings.toJSON(message.analysis);
    }
    if (message.observerId !== undefined) {
      obj.observerId = message.observerId;
    }
    if (message.provider !== 0) {
      obj.provider = gitProviderToJSON(message.provider);
    }
    return obj;
  },

  create(base?: DeepPartial<RepoMetadata>): RepoMetadata {
    return RepoMetadata.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoMetadata>): RepoMetadata {
    const message = createBaseRepoMetadata();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.analysis = (object.analysis !== undefined && object.analysis !== null)
      ? RepoAnalysisSettings.fromPartial(object.analysis)
      : undefined;
    message.observerId = object.observerId ?? undefined;
    message.provider = object.provider ?? 0;
    return message;
  },
};

function createBaseRepoAnalysisSettings(): RepoAnalysisSettings {
  return { optOut: false };
}

export const RepoAnalysisSettings: MessageFns<RepoAnalysisSettings> = {
  encode(message: RepoAnalysisSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.optOut !== false) {
      writer.uint32(8).bool(message.optOut);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoAnalysisSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoAnalysisSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.optOut = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoAnalysisSettings {
    return {
      optOut: isSet(object.optOut)
        ? globalThis.Boolean(object.optOut)
        : isSet(object.opt_out)
        ? globalThis.Boolean(object.opt_out)
        : false,
    };
  },

  toJSON(message: RepoAnalysisSettings): unknown {
    const obj: any = {};
    if (message.optOut !== false) {
      obj.optOut = message.optOut;
    }
    return obj;
  },

  create(base?: DeepPartial<RepoAnalysisSettings>): RepoAnalysisSettings {
    return RepoAnalysisSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoAnalysisSettings>): RepoAnalysisSettings {
    const message = createBaseRepoAnalysisSettings();
    message.optOut = object.optOut ?? false;
    return message;
  },
};

function createBaseRepositorySummary(): RepositorySummary {
  return {
    id: "",
    summary: undefined,
    error: undefined,
    repoName: "",
    companyId: 0,
    provider: 0,
    shortSummary: undefined,
    updatedAt: undefined,
  };
}

export const RepositorySummary: MessageFns<RepositorySummary> = {
  encode(message: RepositorySummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.summary !== undefined) {
      writer.uint32(18).string(message.summary);
    }
    if (message.error !== undefined) {
      ErrorInfo.encode(message.error, writer.uint32(26).fork()).join();
    }
    if (message.repoName !== "") {
      writer.uint32(34).string(message.repoName);
    }
    if (message.companyId !== 0) {
      writer.uint32(40).int32(message.companyId);
    }
    if (message.provider !== 0) {
      writer.uint32(48).int32(message.provider);
    }
    if (message.shortSummary !== undefined) {
      writer.uint32(58).string(message.shortSummary);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepositorySummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepositorySummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.error = ErrorInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.repoName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.shortSummary = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepositorySummary {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      summary: isSet(object.summary) ? globalThis.String(object.summary) : undefined,
      error: isSet(object.error) ? ErrorInfo.fromJSON(object.error) : undefined,
      repoName: isSet(object.repoName)
        ? globalThis.String(object.repoName)
        : isSet(object.repo_name)
        ? globalThis.String(object.repo_name)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      provider: isSet(object.provider) ? gitProviderFromJSON(object.provider) : 0,
      shortSummary: isSet(object.shortSummary)
        ? globalThis.String(object.shortSummary)
        : isSet(object.short_summary)
        ? globalThis.String(object.short_summary)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: RepositorySummary): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.summary !== undefined) {
      obj.summary = message.summary;
    }
    if (message.error !== undefined) {
      obj.error = ErrorInfo.toJSON(message.error);
    }
    if (message.repoName !== "") {
      obj.repoName = message.repoName;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.provider !== 0) {
      obj.provider = gitProviderToJSON(message.provider);
    }
    if (message.shortSummary !== undefined) {
      obj.shortSummary = message.shortSummary;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<RepositorySummary>): RepositorySummary {
    return RepositorySummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepositorySummary>): RepositorySummary {
    const message = createBaseRepositorySummary();
    message.id = object.id ?? "";
    message.summary = object.summary ?? undefined;
    message.error = (object.error !== undefined && object.error !== null)
      ? ErrorInfo.fromPartial(object.error)
      : undefined;
    message.repoName = object.repoName ?? "";
    message.companyId = object.companyId ?? 0;
    message.provider = object.provider ?? 0;
    message.shortSummary = object.shortSummary ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseCodeResearchOrgMeta(): CodeResearchOrgMeta {
  return { data: "" };
}

export const CodeResearchOrgMeta: MessageFns<CodeResearchOrgMeta> = {
  encode(message: CodeResearchOrgMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== "") {
      writer.uint32(10).string(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CodeResearchOrgMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCodeResearchOrgMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CodeResearchOrgMeta {
    return { data: isSet(object.data) ? globalThis.String(object.data) : "" };
  },

  toJSON(message: CodeResearchOrgMeta): unknown {
    const obj: any = {};
    if (message.data !== "") {
      obj.data = message.data;
    }
    return obj;
  },

  create(base?: DeepPartial<CodeResearchOrgMeta>): CodeResearchOrgMeta {
    return CodeResearchOrgMeta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CodeResearchOrgMeta>): CodeResearchOrgMeta {
    const message = createBaseCodeResearchOrgMeta();
    message.data = object.data ?? "";
    return message;
  },
};

function createBaseWebSiteSummary(): WebSiteSummary {
  return { url: "", summary: undefined, error: undefined, companyId: 0 };
}

export const WebSiteSummary: MessageFns<WebSiteSummary> = {
  encode(message: WebSiteSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.summary !== undefined) {
      writer.uint32(18).string(message.summary);
    }
    if (message.error !== undefined) {
      ErrorInfo.encode(message.error, writer.uint32(26).fork()).join();
    }
    if (message.companyId !== 0) {
      writer.uint32(32).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebSiteSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebSiteSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.error = ErrorInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebSiteSummary {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      summary: isSet(object.summary) ? globalThis.String(object.summary) : undefined,
      error: isSet(object.error) ? ErrorInfo.fromJSON(object.error) : undefined,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: WebSiteSummary): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.summary !== undefined) {
      obj.summary = message.summary;
    }
    if (message.error !== undefined) {
      obj.error = ErrorInfo.toJSON(message.error);
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<WebSiteSummary>): WebSiteSummary {
    return WebSiteSummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WebSiteSummary>): WebSiteSummary {
    const message = createBaseWebSiteSummary();
    message.url = object.url ?? "";
    message.summary = object.summary ?? undefined;
    message.error = (object.error !== undefined && object.error !== null)
      ? ErrorInfo.fromPartial(object.error)
      : undefined;
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseSignedLink(): SignedLink {
  return { id: "", expiresAt: undefined, companyId: 0, target: undefined };
}

export const SignedLink: MessageFns<SignedLink> = {
  encode(message: SignedLink, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.expiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expiresAt), writer.uint32(18).fork()).join();
    }
    if (message.companyId !== 0) {
      writer.uint32(24).int32(message.companyId);
    }
    if (message.target !== undefined) {
      SignedLinkTarget.encode(message.target, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignedLink {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignedLink();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.expiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.target = SignedLinkTarget.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SignedLink {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      expiresAt: isSet(object.expiresAt)
        ? fromJsonTimestamp(object.expiresAt)
        : isSet(object.expires_at)
        ? fromJsonTimestamp(object.expires_at)
        : undefined,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      target: isSet(object.target) ? SignedLinkTarget.fromJSON(object.target) : undefined,
    };
  },

  toJSON(message: SignedLink): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt.toISOString();
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.target !== undefined) {
      obj.target = SignedLinkTarget.toJSON(message.target);
    }
    return obj;
  },

  create(base?: DeepPartial<SignedLink>): SignedLink {
    return SignedLink.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SignedLink>): SignedLink {
    const message = createBaseSignedLink();
    message.id = object.id ?? "";
    message.expiresAt = object.expiresAt ?? undefined;
    message.companyId = object.companyId ?? 0;
    message.target = (object.target !== undefined && object.target !== null)
      ? SignedLinkTarget.fromPartial(object.target)
      : undefined;
    return message;
  },
};

function createBaseSignedLinkTarget(): SignedLinkTarget {
  return { type: undefined };
}

export const SignedLinkTarget: MessageFns<SignedLinkTarget> = {
  encode(message: SignedLinkTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.type?.$case) {
      case "documentContent":
        SignedLinkTarget_DocumentContent.encode(message.type.value, writer.uint32(802).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignedLinkTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignedLinkTarget();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = {
            $case: "documentContent",
            value: SignedLinkTarget_DocumentContent.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SignedLinkTarget {
    return {
      type: isSet(object.documentContent)
        ? { $case: "documentContent", value: SignedLinkTarget_DocumentContent.fromJSON(object.documentContent) }
        : isSet(object.document_content)
        ? { $case: "documentContent", value: SignedLinkTarget_DocumentContent.fromJSON(object.document_content) }
        : undefined,
    };
  },

  toJSON(message: SignedLinkTarget): unknown {
    const obj: any = {};
    if (message.type?.$case === "documentContent") {
      obj.documentContent = SignedLinkTarget_DocumentContent.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<SignedLinkTarget>): SignedLinkTarget {
    return SignedLinkTarget.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SignedLinkTarget>): SignedLinkTarget {
    const message = createBaseSignedLinkTarget();
    switch (object.type?.$case) {
      case "documentContent": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = {
            $case: "documentContent",
            value: SignedLinkTarget_DocumentContent.fromPartial(object.type.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseSignedLinkTarget_DocumentContent(): SignedLinkTarget_DocumentContent {
  return { id: "" };
}

export const SignedLinkTarget_DocumentContent: MessageFns<SignedLinkTarget_DocumentContent> = {
  encode(message: SignedLinkTarget_DocumentContent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignedLinkTarget_DocumentContent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignedLinkTarget_DocumentContent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SignedLinkTarget_DocumentContent {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: SignedLinkTarget_DocumentContent): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<SignedLinkTarget_DocumentContent>): SignedLinkTarget_DocumentContent {
    return SignedLinkTarget_DocumentContent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SignedLinkTarget_DocumentContent>): SignedLinkTarget_DocumentContent {
    const message = createBaseSignedLinkTarget_DocumentContent();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseJiraField(): JiraField {
  return { id: "", key: "", name: "", type: 0, required: false, hasDefault: false, schema: undefined, options: [] };
}

export const JiraField: MessageFns<JiraField> = {
  encode(message: JiraField, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.key !== "") {
      writer.uint32(18).string(message.key);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.required !== false) {
      writer.uint32(40).bool(message.required);
    }
    if (message.hasDefault !== false) {
      writer.uint32(48).bool(message.hasDefault);
    }
    if (message.schema !== undefined) {
      JiraFieldSchema.encode(message.schema, writer.uint32(58).fork()).join();
    }
    for (const v of message.options) {
      JiraFieldOption.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraField {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraField();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.required = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.hasDefault = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.schema = JiraFieldSchema.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.options.push(JiraFieldOption.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraField {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      type: isSet(object.type) ? jiraField_JiraFieldTypeFromJSON(object.type) : 0,
      required: isSet(object.required) ? globalThis.Boolean(object.required) : false,
      hasDefault: isSet(object.hasDefault)
        ? globalThis.Boolean(object.hasDefault)
        : isSet(object.has_default)
        ? globalThis.Boolean(object.has_default)
        : false,
      schema: isSet(object.schema) ? JiraFieldSchema.fromJSON(object.schema) : undefined,
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => JiraFieldOption.fromJSON(e))
        : [],
    };
  },

  toJSON(message: JiraField): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.type !== 0) {
      obj.type = jiraField_JiraFieldTypeToJSON(message.type);
    }
    if (message.required !== false) {
      obj.required = message.required;
    }
    if (message.hasDefault !== false) {
      obj.hasDefault = message.hasDefault;
    }
    if (message.schema !== undefined) {
      obj.schema = JiraFieldSchema.toJSON(message.schema);
    }
    if (message.options?.length) {
      obj.options = message.options.map((e) => JiraFieldOption.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<JiraField>): JiraField {
    return JiraField.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraField>): JiraField {
    const message = createBaseJiraField();
    message.id = object.id ?? "";
    message.key = object.key ?? "";
    message.name = object.name ?? "";
    message.type = object.type ?? 0;
    message.required = object.required ?? false;
    message.hasDefault = object.hasDefault ?? false;
    message.schema = (object.schema !== undefined && object.schema !== null)
      ? JiraFieldSchema.fromPartial(object.schema)
      : undefined;
    message.options = object.options?.map((e) => JiraFieldOption.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJiraFieldSchema(): JiraFieldSchema {
  return { items: undefined, custom: undefined };
}

export const JiraFieldSchema: MessageFns<JiraFieldSchema> = {
  encode(message: JiraFieldSchema, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.items !== undefined) {
      writer.uint32(10).string(message.items);
    }
    if (message.custom !== undefined) {
      writer.uint32(18).string(message.custom);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraFieldSchema {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraFieldSchema();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.custom = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraFieldSchema {
    return {
      items: isSet(object.items) ? globalThis.String(object.items) : undefined,
      custom: isSet(object.custom) ? globalThis.String(object.custom) : undefined,
    };
  },

  toJSON(message: JiraFieldSchema): unknown {
    const obj: any = {};
    if (message.items !== undefined) {
      obj.items = message.items;
    }
    if (message.custom !== undefined) {
      obj.custom = message.custom;
    }
    return obj;
  },

  create(base?: DeepPartial<JiraFieldSchema>): JiraFieldSchema {
    return JiraFieldSchema.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraFieldSchema>): JiraFieldSchema {
    const message = createBaseJiraFieldSchema();
    message.items = object.items ?? undefined;
    message.custom = object.custom ?? undefined;
    return message;
  },
};

function createBaseJiraFieldOption(): JiraFieldOption {
  return { id: "", value: "", label: "" };
}

export const JiraFieldOption: MessageFns<JiraFieldOption> = {
  encode(message: JiraFieldOption, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    if (message.label !== "") {
      writer.uint32(26).string(message.label);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JiraFieldOption {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJiraFieldOption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.label = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JiraFieldOption {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
    };
  },

  toJSON(message: JiraFieldOption): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    return obj;
  },

  create(base?: DeepPartial<JiraFieldOption>): JiraFieldOption {
    return JiraFieldOption.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JiraFieldOption>): JiraFieldOption {
    const message = createBaseJiraFieldOption();
    message.id = object.id ?? "";
    message.value = object.value ?? "";
    message.label = object.label ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
